var Ne = Object.defineProperty;
var Oe = (n, e, t) => e in n ? Ne(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var h = (n, e, t) => Oe(n, typeof e != "symbol" ? e + "" : e, t);
import { Slice as N, Fragment as A, DOMSerializer as he, DOMParser as Fe, Node as He } from "prosemirror-model";
import { ReplaceStep as $e, ReplaceAroundStep as V } from "prosemirror-transform";
import { n as U, i as O, g as B, b as Y, a as b, t as Ve, U as F, q as _, r as H, d as Ue, s as ze, u as Ge, v as q, w as S, x as me, y as Re, z as ke, A as z } from "./blockToNode-DBNbhwwC.js";
import { B as es, G as ts, C as os, D as ns, N as ss, E as rs, O as is, F as as, H as cs, I as ls, L as ds, J as us, M as ps, K as fs } from "./blockToNode-DBNbhwwC.js";
import { ak as $, al as je, am as We, an as Ke, aj as E, ao as Je, ap as Ye, a5 as qe, a8 as G, aq as Qe, ar as Xe, a6 as Ze, as as Q, a9 as ge, at as et } from "./defaultBlocks-DgA_mtQV.js";
import { aw as ms, av as ks, E as gs, a as bs, F as ys, r as Ss, N as Bs, a4 as Cs, ad as Es, aG as xs, ax as Ms, b as ws, d as Ts, e as Ps, a0 as vs, aM as Is, au as As, c as _s, f as Ds, ag as Ls, ah as Ns, aB as Os, x as Fs, y as Hs, A as $s, z as Vs, g as Us, h as zs, T as Gs, j as Rs, k as js, l as Ws, n as Ks, o as Js, q as Ys, s as qs, w as Qs, aC as Xs, aH as Zs, B as er, C as tr, H as or, I as nr, J as sr, K as rr, aE as ir, aI as ar, M as cr, D as lr, G as dr, S as ur, O as pr, Q as fr, W as hr, U as mr, _ as kr, Z as gr, a2 as br, Y as yr, X as Sr, R as Br, $ as Cr, m as Er, aN as xr, aK as Mr, az as wr, af as Tr, i as Pr, ay as vr, aD as Ir, ae as Ar, a7 as _r, t as Dr, u as Lr, v as Nr, aJ as Or, ai as Fr, aL as Hr, a1 as $r, V as Vr, p as Ur, a3 as zr, aF as Gr, L as Rr, aO as jr, P as Wr, aA as Kr } from "./defaultBlocks-DgA_mtQV.js";
import { j as tt, k as be, l as ot, m as nt, n as st, c as R, B as rt, D as it, L as at, N as ct, P as lt, g as dt, i as ut, F as pt, Y as ft, a as ht, b as mt, S as kt, H as gt, h as bt, e as yt, V as St, d as Bt } from "./TrailingNode-B_zPMWxw.js";
import { s as Ct, B as Et } from "./BlockNoteSchema-C-l154WP.js";
import { C as Yr, b as qr, c as Qr, a as Xr, g as Zr, u as ei, w as ti } from "./BlockNoteSchema-C-l154WP.js";
import { Node as D, Extension as x, mergeAttributes as xt, Mark as X, extensions as I, isNodeSelection as Mt, posToDOMRect as wt, selectionToInsertionEnd as Tt, getSchema as Pt, createDocument as vt, Editor as It } from "@tiptap/core";
import { E as ye } from "./EventEmitter-CjSwpTbz.js";
import { Fragment as Z, Slice as ne } from "@tiptap/pm/model";
import { e as At } from "./en-njEqD7AG.js";
import { inputRules as _t, InputRule as Dt } from "@handlewithcare/prosemirror-inputrules";
import { keymap as Lt } from "@tiptap/pm/keymap";
import { o as Nt } from "./BlockNoteExtension-C2X7LW-V.js";
import { c as ni, a as si } from "./BlockNoteExtension-C2X7LW-V.js";
import { Gapcursor as Ot } from "@tiptap/extension-gapcursor";
import { Link as Ft } from "@tiptap/extension-link";
import { Text as Ht } from "@tiptap/extension-text";
import { NodeSelection as L, TextSelection as M, Plugin as ee } from "prosemirror-state";
import { CellSelection as te, TableMap as se } from "prosemirror-tables";
import { S as $t } from "./ShowSelection-Dz-NEase.js";
import Vt from "remark-gfm";
import Ut from "remark-parse";
import zt, { defaultHandlers as re } from "remark-rehype";
import Gt from "rehype-stringify";
import { unified as Rt } from "unified";
import { TextSelection as jt } from "@tiptap/pm/state";
function Wt(n, e) {
  const t = [
    {
      tag: `[data-inline-content-type="${n.type}"]`,
      contentElement: (o) => {
        const s = o;
        return s.matches("[data-editable]") ? s : s.querySelector("[data-editable]") || s;
      }
    }
  ];
  return e && t.push({
    tag: "*",
    getAttrs(o) {
      if (typeof o == "string")
        return !1;
      const s = e == null ? void 0 : e(o);
      return s === void 0 ? !1 : s;
    }
  }), t;
}
function Jn(n, e) {
  var o;
  const t = D.create({
    name: n.type,
    inline: !0,
    group: "inline",
    draggable: (o = e.meta) == null ? void 0 : o.draggable,
    selectable: n.content === "styled",
    atom: n.content === "none",
    content: n.content === "styled" ? "inline*" : "",
    addAttributes() {
      return We(n.propSchema);
    },
    addKeyboardShortcuts() {
      return je(n);
    },
    parseHTML() {
      return Wt(
        n,
        e.parse
      );
    },
    renderHTML({ node: s }) {
      const i = this.options.editor, r = e.render.call(
        { renderType: "dom", props: void 0 },
        U(
          s,
          i.schema.inlineContentSchema,
          i.schema.styleSchema
        ),
        // TODO: fix cast
        () => {
        },
        i
      );
      return $(
        r,
        n.type,
        s.attrs,
        n.propSchema
      );
    },
    addNodeView() {
      return (s) => {
        const { node: i, getPos: r } = s, c = this.options.editor, a = e.render.call(
          { renderType: "nodeView", props: s },
          U(
            i,
            c.schema.inlineContentSchema,
            c.schema.styleSchema
          ),
          // TODO: fix cast
          (l) => {
            const d = O([l], c.pmSchema), u = r();
            u && c.transact(
              (p) => p.replaceWith(u, u + i.nodeSize, d)
            );
          },
          c
        );
        return $(
          a,
          n.type,
          i.attrs,
          n.propSchema
        );
      };
    }
  });
  return Ke(
    t,
    n.propSchema,
    {
      ...e,
      toExternalHTML: e.toExternalHTML,
      render(s, i, r) {
        const c = e.render(
          s,
          i,
          r
        );
        return $(
          c,
          n.type,
          s.props,
          n.propSchema
        );
      }
    }
  );
}
function Kt(n, e, t, o = "before") {
  const s = typeof t == "string" ? t : t.id, i = B(n), r = e.map(
    (d) => Y(d, i)
  ), c = E(s, n.doc);
  if (!c)
    throw new Error(`Block with ID ${s} not found`);
  let a = c.posBeforeNode;
  return o === "after" && (a += c.node.nodeSize), n.step(
    new $e(a, a, new N(A.from(r), 0, 0))
  ), r.map(
    (d) => b(d, i)
  );
}
function j(n) {
  if (!n || n.type.name !== "column")
    throw new Error("Invalid columnPos: does not point to column node.");
  const e = n.firstChild;
  if (!e)
    throw new Error("Invalid column: does not have child node.");
  const t = e.firstChild;
  if (!t)
    throw new Error("Invalid blockContainer: does not have child node.");
  return n.childCount === 1 && e.childCount === 1 && t.type.name === "paragraph" && t.content.content.length === 0;
}
function Jt(n, e) {
  const t = n.doc.resolve(e), o = t.nodeAfter;
  if (!o || o.type.name !== "columnList")
    throw new Error(
      "Invalid columnListPos: does not point to columnList node."
    );
  for (let s = o.childCount - 1; s >= 0; s--) {
    const i = n.doc.resolve(t.pos + 1).posAtIndex(s), c = n.doc.resolve(i).nodeAfter;
    if (!c || c.type.name !== "column")
      throw new Error("Invalid columnPos: does not point to column node.");
    j(c) && n.delete(i, i + c.nodeSize);
  }
}
function W(n, e) {
  Jt(n, e);
  const o = n.doc.resolve(e).nodeAfter;
  if (!o || o.type.name !== "columnList")
    throw new Error(
      "Invalid columnListPos: does not point to columnList node."
    );
  if (o.childCount > 2)
    return;
  if (o.childCount < 2)
    throw new Error("Invalid columnList: contains fewer than two children.");
  const s = e + 1, r = n.doc.resolve(s).nodeAfter, c = e + o.nodeSize - 1, l = n.doc.resolve(c).nodeBefore;
  if (!r || !l)
    throw new Error("Invalid columnList: does not contain children.");
  const d = j(r), u = j(l);
  if (d && u) {
    n.delete(e, e + o.nodeSize);
    return;
  }
  if (d) {
    n.step(
      new V(
        // Replaces `columnList`.
        e,
        e + o.nodeSize,
        // Replaces with content of last `column`.
        c - l.nodeSize + 1,
        c - 1,
        // Doesn't append anything.
        N.empty,
        0,
        !1
      )
    );
    return;
  }
  if (u) {
    n.step(
      new V(
        // Replaces `columnList`.
        e,
        e + o.nodeSize,
        // Replaces with content of first `column`.
        s + 1,
        s + r.nodeSize - 1,
        // Doesn't append anything.
        N.empty,
        0,
        !1
      )
    );
    return;
  }
}
function ie(n, e, t) {
  const o = B(n), s = t.map(
    (u) => Y(u, o)
  ), i = new Set(
    e.map(
      (u) => typeof u == "string" ? u : u.id
    )
  ), r = [], c = /* @__PURE__ */ new Set(), a = typeof e[0] == "string" ? e[0] : e[0].id;
  let l = 0;
  if (n.doc.descendants((u, p) => {
    if (i.size === 0)
      return !1;
    if (!u.type.isInGroup("bnBlock") || !i.has(u.attrs.id))
      return !0;
    if (r.push(b(u, o)), i.delete(u.attrs.id), t.length > 0 && u.attrs.id === a) {
      const g = n.doc.nodeSize;
      n.insert(p, s);
      const y = n.doc.nodeSize;
      l += g - y;
    }
    const m = n.doc.nodeSize, f = n.doc.resolve(p - l);
    f.node().type.name === "column" ? c.add(f.before(-1)) : f.node().type.name === "columnList" && c.add(f.before()), f.node().type.name === "blockGroup" && f.node(f.depth - 1).type.name !== "doc" && f.node().childCount === 1 ? n.delete(f.before(), f.after()) : n.delete(p - l, p - l + u.nodeSize);
    const k = n.doc.nodeSize;
    return l += m - k, !1;
  }), i.size > 0) {
    const u = [...i].join(`
`);
    throw Error(
      "Blocks with the following IDs could not be found in the editor: " + u
    );
  }
  return c.forEach((u) => W(n, u)), { insertedBlocks: s.map(
    (u) => b(u, o)
  ), removedBlocks: r };
}
function Yt(n, e, t, o, s) {
  let i;
  if (e)
    if (typeof e == "string")
      i = O([e], n.pmSchema, o);
    else if (Array.isArray(e))
      i = O(e, n.pmSchema, o);
    else if (e.type === "tableContent")
      i = Ve(e, n.pmSchema);
    else
      throw new F(e.type);
  else throw new Error("blockContent is required");
  const c = ((s == null ? void 0 : s.document) ?? document).createDocumentFragment();
  for (const a of i)
    if (a.type.name !== "text" && n.schema.inlineContentSchema[a.type.name]) {
      const l = n.schema.inlineContentSpecs[a.type.name].implementation;
      if (l) {
        const d = U(
          a,
          n.schema.inlineContentSchema,
          n.schema.styleSchema
        ), u = l.render.call(
          {
            renderType: "dom",
            props: void 0
          },
          d,
          () => {
          },
          n
        );
        if (u) {
          if (c.appendChild(u.dom), u.contentDOM) {
            const p = t.serializeFragment(
              a.content,
              s
            );
            u.contentDOM.dataset.editable = "", u.contentDOM.appendChild(p);
          }
          continue;
        }
      }
    } else if (a.type.name === "text") {
      let l = document.createTextNode(
        a.textContent
      );
      for (const d of a.marks.toReversed())
        if (d.type.name in n.schema.styleSpecs) {
          const u = n.schema.styleSpecs[d.type.name].implementation.render(d.attrs.stringValue, n);
          u.contentDOM.appendChild(l), l = u.dom;
        } else {
          const u = d.type.spec.toDOM(d, !0), p = he.renderSpec(document, u);
          p.contentDOM.appendChild(l), l = p.dom;
        }
      c.appendChild(l);
    } else {
      const l = t.serializeFragment(
        A.from([a]),
        s
      );
      c.appendChild(l);
    }
  return c;
}
function qt(n, e, t, o) {
  var u, p, m, f, k;
  const s = n.pmSchema.nodes.blockContainer, i = e.props || {};
  for (const [g, y] of Object.entries(
    n.schema.blockSchema[e.type].propSchema
  ))
    !(g in i) && y.default !== void 0 && (i[g] = y.default);
  const r = e.children || [], a = n.blockImplementations[e.type].implementation.render.call(
    {
      renderType: "dom",
      props: void 0
    },
    { ...e, props: i, children: r },
    n
  );
  if (a.contentDOM && e.content) {
    const g = Yt(
      n,
      e.content,
      // TODO
      t,
      e.type,
      o
    );
    a.contentDOM.appendChild(g);
  }
  if (n.pmSchema.nodes[e.type].isInGroup("bnBlock")) {
    if (e.children && e.children.length > 0) {
      const g = Se(
        n,
        e.children,
        t,
        o
      );
      (u = a.contentDOM) == null || u.append(g);
    }
    return a.dom;
  }
  const d = (m = (p = s.spec) == null ? void 0 : p.toDOM) == null ? void 0 : m.call(
    p,
    s.create({
      id: e.id,
      ...i
    })
  );
  return (f = d.contentDOM) == null || f.appendChild(a.dom), e.children && e.children.length > 0 && ((k = d.contentDOM) == null || k.appendChild(
    Be(n, e.children, t, o)
  )), d.dom;
}
function Se(n, e, t, o) {
  const i = ((o == null ? void 0 : o.document) ?? document).createDocumentFragment();
  for (const r of e) {
    const c = qt(n, r, t, o);
    i.appendChild(c);
  }
  return i;
}
const Be = (n, e, t, o) => {
  var c;
  const s = n.pmSchema.nodes.blockGroup, i = s.spec.toDOM(s.create({})), r = Se(n, e, t, o);
  return (c = i.contentDOM) == null || c.appendChild(r), i.dom;
}, Qt = (n, e) => {
  const t = he.fromSchema(n);
  return {
    serializeBlocks: (o, s) => Be(e, o, t, s).outerHTML
  };
};
function Xt(n) {
  return n.transact((e) => {
    const t = _(e.doc, e.selection.anchor);
    if (e.selection instanceof te)
      return {
        type: "cell",
        anchorBlockId: t.node.attrs.id,
        anchorCellOffset: e.selection.$anchorCell.pos - t.posBeforeNode,
        headCellOffset: e.selection.$headCell.pos - t.posBeforeNode
      };
    if (e.selection instanceof L)
      return {
        type: "node",
        anchorBlockId: t.node.attrs.id
      };
    {
      const o = _(e.doc, e.selection.head);
      return {
        type: "text",
        anchorBlockId: t.node.attrs.id,
        headBlockId: o.node.attrs.id,
        anchorOffset: e.selection.anchor - t.posBeforeNode,
        headOffset: e.selection.head - o.posBeforeNode
      };
    }
  });
}
function Zt(n, e) {
  var s, i;
  const t = (s = E(e.anchorBlockId, n.doc)) == null ? void 0 : s.posBeforeNode;
  if (t === void 0)
    throw new Error(
      `Could not find block with ID ${e.anchorBlockId} to update selection`
    );
  let o;
  if (e.type === "cell")
    o = te.create(
      n.doc,
      t + e.anchorCellOffset,
      t + e.headCellOffset
    );
  else if (e.type === "node")
    o = L.create(n.doc, t + 1);
  else {
    const r = (i = E(e.headBlockId, n.doc)) == null ? void 0 : i.posBeforeNode;
    if (r === void 0)
      throw new Error(
        `Could not find block with ID ${e.headBlockId} to update selection`
      );
    o = M.create(
      n.doc,
      t + e.anchorOffset,
      r + e.headOffset
    );
  }
  n.setSelection(o);
}
function K(n) {
  return n.map((e) => e.type === "columnList" ? e.children.map((t) => K(t.children)).flat() : {
    ...e,
    children: K(e.children)
  }).flat();
}
function Ce(n, e, t) {
  n.transact((o) => {
    var r;
    const s = ((r = n.getSelection()) == null ? void 0 : r.blocks) || [
      n.getTextCursorPosition().block
    ], i = Xt(n);
    n.removeBlocks(s), n.insertBlocks(K(s), e, t), Zt(o, i);
  });
}
function Ee(n) {
  return !n || n.type !== "columnList";
}
function xe(n, e, t) {
  let o, s;
  if (e ? e.children.length > 0 ? (o = e.children[e.children.length - 1], s = "after") : (o = e, s = "before") : t && (o = t, s = "before"), !o || !s)
    return;
  const i = n.getParentBlock(o);
  return Ee(i) ? { referenceBlock: o, placement: s } : xe(
    n,
    s === "after" ? o : n.getPrevBlock(o),
    i
  );
}
function Me(n, e, t) {
  let o, s;
  if (e ? e.children.length > 0 ? (o = e.children[0], s = "before") : (o = e, s = "after") : t && (o = t, s = "after"), !o || !s)
    return;
  const i = n.getParentBlock(o);
  return Ee(i) ? { referenceBlock: o, placement: s } : Me(
    n,
    s === "before" ? o : n.getNextBlock(o),
    i
  );
}
function eo(n) {
  n.transact(() => {
    const e = n.getSelection(), t = (e == null ? void 0 : e.blocks[0]) || n.getTextCursorPosition().block, o = xe(
      n,
      n.getPrevBlock(t),
      n.getParentBlock(t)
    );
    o && Ce(
      n,
      o.referenceBlock,
      o.placement
    );
  });
}
function to(n) {
  n.transact(() => {
    const e = n.getSelection(), t = (e == null ? void 0 : e.blocks[(e == null ? void 0 : e.blocks.length) - 1]) || n.getTextCursorPosition().block, o = Me(
      n,
      n.getNextBlock(t),
      n.getParentBlock(t)
    );
    o && Ce(
      n,
      o.referenceBlock,
      o.placement
    );
  });
}
function oo(n, e, t) {
  const { $from: o, $to: s } = n.selection, i = o.blockRange(
    s,
    (f) => f.childCount > 0 && (f.type.name === "blockGroup" || f.type.name === "column")
    // change necessary to not look at first item child type
  );
  if (!i)
    return !1;
  const r = i.startIndex;
  if (r === 0)
    return !1;
  const a = i.parent.child(r - 1);
  if (a.type !== e)
    return !1;
  const l = a.lastChild && a.lastChild.type === t, d = A.from(l ? e.create() : null), u = new N(
    A.from(
      e.create(null, A.from(t.create(null, d)))
      // change necessary to create "groupType" instead of parent.type
    ),
    l ? 3 : 1,
    0
  ), p = i.start, m = i.end;
  return n.step(
    new V(
      p - (l ? 3 : 1),
      m,
      p,
      m,
      u,
      1,
      !0
    )
  ).scrollIntoView(), !0;
}
function we(n) {
  return n.transact((e) => oo(
    e,
    n.pmSchema.nodes.blockContainer,
    n.pmSchema.nodes.blockGroup
  ));
}
function no(n) {
  n._tiptapEditor.commands.liftListItem("blockContainer");
}
function so(n) {
  return n.transact((e) => {
    const { bnBlock: t } = H(e);
    return e.doc.resolve(t.beforePos).nodeBefore !== null;
  });
}
function ro(n) {
  return n.transact((e) => {
    const { bnBlock: t } = H(e);
    return e.doc.resolve(t.beforePos).depth > 1;
  });
}
function io(n, e) {
  const t = typeof e == "string" ? e : e.id, o = B(n), s = E(t, n);
  if (s)
    return b(s.node, o);
}
function ao(n, e) {
  const t = typeof e == "string" ? e : e.id, o = E(t, n), s = B(n);
  if (!o)
    return;
  const r = n.resolve(o.posBeforeNode).nodeBefore;
  if (r)
    return b(r, s);
}
function co(n, e) {
  const t = typeof e == "string" ? e : e.id, o = E(t, n), s = B(n);
  if (!o)
    return;
  const r = n.resolve(
    o.posBeforeNode + o.node.nodeSize
  ).nodeAfter;
  if (r)
    return b(r, s);
}
function lo(n, e) {
  const t = typeof e == "string" ? e : e.id, o = B(n), s = E(t, n);
  if (!s)
    return;
  const i = n.resolve(s.posBeforeNode), r = i.node(), c = i.node(-1), a = c.type.name !== "doc" ? r.type.name === "blockGroup" ? c : r : void 0;
  if (a)
    return b(a, o);
}
class uo {
  constructor(e) {
    this.editor = e;
  }
  /**
   * Gets a snapshot of all top-level (non-nested) blocks in the editor.
   * @returns A snapshot of all top-level (non-nested) blocks in the editor.
   */
  get document() {
    return this.editor.transact((e) => Ue(e.doc, this.editor.pmSchema));
  }
  /**
   * Gets a snapshot of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block that should be
   * retrieved.
   * @returns The block that matches the identifier, or `undefined` if no
   * matching block was found.
   */
  getBlock(e) {
    return this.editor.transact((t) => io(t.doc, e));
  }
  /**
   * Gets a snapshot of the previous sibling of an existing block from the
   * editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * previous sibling should be retrieved.
   * @returns The previous sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the first child/block
   * in the document.
   */
  getPrevBlock(e) {
    return this.editor.transact((t) => ao(t.doc, e));
  }
  /**
   * Gets a snapshot of the next sibling of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * next sibling should be retrieved.
   * @returns The next sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the last child/block in
   * the document.
   */
  getNextBlock(e) {
    return this.editor.transact((t) => co(t.doc, e));
  }
  /**
   * Gets a snapshot of the parent of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * parent should be retrieved.
   * @returns The parent of the block that matches the identifier. `undefined`
   * if no matching block was found, or the block isn't nested.
   */
  getParentBlock(e) {
    return this.editor.transact(
      (t) => lo(t.doc, e)
    );
  }
  /**
   * Traverses all blocks in the editor depth-first, and executes a callback for each.
   * @param callback The callback to execute for each block. Returning `false` stops the traversal.
   * @param reverse Whether the blocks should be traversed in reverse order.
   */
  forEachBlock(e, t = !1) {
    const o = this.document.slice();
    t && o.reverse();
    function s(i) {
      for (const r of i) {
        if (e(r) === !1)
          return !1;
        const c = t ? r.children.slice().reverse() : r.children;
        if (!s(c))
          return !1;
      }
      return !0;
    }
    s(o);
  }
  /**
   * Inserts new blocks into the editor. If a block's `id` is undefined, BlockNote generates one automatically. Throws an
   * error if the reference block could not be found.
   * @param blocksToInsert An array of partial blocks that should be inserted.
   * @param referenceBlock An identifier for an existing block, at which the new blocks should be inserted.
   * @param placement Whether the blocks should be inserted just before, just after, or nested inside the
   * `referenceBlock`.
   */
  insertBlocks(e, t, o = "before") {
    return this.editor.transact(
      (s) => Kt(s, e, t, o)
    );
  }
  /**
   * Updates an existing block in the editor. Since updatedBlock is a PartialBlock object, some fields might not be
   * defined. These undefined fields are kept as-is from the existing block. Throws an error if the block to update could
   * not be found.
   * @param blockToUpdate The block that should be updated.
   * @param update A partial block which defines how the existing block should be changed.
   */
  updateBlock(e, t) {
    return this.editor.transact((o) => Je(o, e, t));
  }
  /**
   * Removes existing blocks from the editor. Throws an error if any of the blocks could not be found.
   * @param blocksToRemove An array of identifiers for existing blocks that should be removed.
   */
  removeBlocks(e) {
    return this.editor.transact(
      (t) => ie(t, e, []).removedBlocks
    );
  }
  /**
   * Replaces existing blocks in the editor with new blocks. If the blocks that should be removed are not adjacent or
   * are at different nesting levels, `blocksToInsert` will be inserted at the position of the first block in
   * `blocksToRemove`. Throws an error if any of the blocks to remove could not be found.
   * @param blocksToRemove An array of blocks that should be replaced.
   * @param blocksToInsert An array of partial blocks to replace the old ones with.
   */
  replaceBlocks(e, t) {
    return this.editor.transact(
      (o) => ie(o, e, t)
    );
  }
  /**
   * Checks if the block containing the text cursor can be nested.
   */
  canNestBlock() {
    return so(this.editor);
  }
  /**
   * Nests the block containing the text cursor into the block above it.
   */
  nestBlock() {
    we(this.editor);
  }
  /**
   * Checks if the block containing the text cursor is nested.
   */
  canUnnestBlock() {
    return ro(this.editor);
  }
  /**
   * Lifts the block containing the text cursor out of its parent.
   */
  unnestBlock() {
    no(this.editor);
  }
  /**
   * Moves the selected blocks up. If the previous block has children, moves
   * them to the end of its children. If there is no previous block, but the
   * current blocks share a common parent, moves them out of & before it.
   */
  moveBlocksUp() {
    return eo(this.editor);
  }
  /**
   * Moves the selected blocks down. If the next block has children, moves
   * them to the start of its children. If there is no next block, but the
   * current blocks share a common parent, moves them out of & after it.
   */
  moveBlocksDown() {
    return to(this.editor);
  }
}
class po extends ye {
  constructor(e) {
    super(), this.editor = e, e.on("create", () => {
      e._tiptapEditor.on(
        "update",
        ({ transaction: t, appendedTransactions: o }) => {
          this.emit("onChange", { editor: e, transaction: t, appendedTransactions: o });
        }
      ), e._tiptapEditor.on("selectionUpdate", ({ transaction: t }) => {
        this.emit("onSelectionChange", { editor: e, transaction: t });
      }), e._tiptapEditor.on("mount", () => {
        this.emit("onMount", { editor: e });
      }), e._tiptapEditor.on("unmount", () => {
        this.emit("onUnmount", { editor: e });
      });
    });
  }
  /**
   * Register a callback that will be called when the editor changes.
   */
  onChange(e, t = !0) {
    const o = ({
      transaction: s,
      appendedTransactions: i
    }) => {
      !t && ae(s) || e(this.editor, {
        getChanges() {
          return tt(
            s,
            i
          );
        }
      });
    };
    return this.on("onChange", o), () => {
      this.off("onChange", o);
    };
  }
  /**
   * Register a callback that will be called when the selection changes.
   */
  onSelectionChange(e, t = !1) {
    const o = (s) => {
      !t && ae(s.transaction) || e(this.editor);
    };
    return this.on("onSelectionChange", o), () => {
      this.off("onSelectionChange", o);
    };
  }
  /**
   * Register a callback that will be called when the editor is mounted.
   */
  onMount(e) {
    return this.on("onMount", e), () => {
      this.off("onMount", e);
    };
  }
  /**
   * Register a callback that will be called when the editor is unmounted.
   */
  onUnmount(e) {
    return this.on("onUnmount", e), () => {
      this.off("onUnmount", e);
    };
  }
}
function ae(n) {
  return !!n.getMeta("y-sync$");
}
function fo(n) {
  return Array.prototype.indexOf.call(n.parentElement.childNodes, n);
}
function ho(n) {
  return n.nodeType === 3 && !/\S/.test(n.nodeValue || "");
}
function mo(n) {
  n.querySelectorAll("li > ul, li > ol").forEach((e) => {
    const t = fo(e), o = e.parentElement, s = Array.from(o.childNodes).slice(
      t + 1
    );
    e.remove(), s.forEach((i) => {
      i.remove();
    }), o.insertAdjacentElement("afterend", e), s.reverse().forEach((i) => {
      if (ho(i))
        return;
      const r = document.createElement("li");
      r.append(i), e.insertAdjacentElement("afterend", r);
    }), o.childNodes.length === 0 && o.remove();
  });
}
function ko(n) {
  n.querySelectorAll("li + ul, li + ol").forEach((e) => {
    var i, r;
    const t = e.previousElementSibling, o = document.createElement("div");
    t.insertAdjacentElement("afterend", o), o.append(t);
    const s = document.createElement("div");
    for (s.setAttribute("data-node-type", "blockGroup"), o.append(s); ((i = o.nextElementSibling) == null ? void 0 : i.nodeName) === "UL" || ((r = o.nextElementSibling) == null ? void 0 : r.nodeName) === "OL"; )
      s.append(o.nextElementSibling);
  });
}
let ce = null;
function go() {
  return ce || (ce = document.implementation.createHTMLDocument("title"));
}
function bo(n) {
  if (typeof n == "string") {
    const e = go().createElement("div");
    e.innerHTML = n, n = e;
  }
  return mo(n), ko(n), n;
}
function Te(n, e) {
  const t = bo(n), s = Fe.fromSchema(e).parse(t, {
    topNode: e.nodes.blockGroup.create()
  }), i = [];
  for (let r = 0; r < s.childCount; r++)
    i.push(b(s.child(r), e));
  return i;
}
function yo(n, e) {
  const t = e.value ? e.value : "", o = {};
  e.lang && (o["data-language"] = e.lang);
  let s = {
    type: "element",
    tagName: "code",
    properties: o,
    children: [{ type: "text", value: t }]
  };
  return e.meta && (s.data = { meta: e.meta }), n.patch(e, s), s = n.applyData(e, s), s = {
    type: "element",
    tagName: "pre",
    properties: {},
    children: [s]
  }, n.patch(e, s), s;
}
function So(n, e) {
  var i;
  const t = String((e == null ? void 0 : e.url) || ""), o = e != null && e.title ? String(e.title) : void 0;
  let s = {
    type: "element",
    tagName: "video",
    properties: {
      src: t,
      "data-name": o,
      "data-url": t,
      controls: !0
    },
    children: []
  };
  return (i = n.patch) == null || i.call(n, e, s), s = n.applyData ? n.applyData(e, s) : s, s;
}
function Pe(n) {
  return Rt().use(Ut).use(Vt).use(zt, {
    handlers: {
      ...re,
      image: (t, o) => {
        const s = String((o == null ? void 0 : o.url) || "");
        return Ye(s) ? So(t, o) : re.image(t, o);
      },
      code: yo
    }
  }).use(Gt).processSync(n).value;
}
function Bo(n, e) {
  const t = Pe(n);
  return Te(t, e);
}
class Co {
  constructor(e) {
    this.editor = e;
  }
  /**
   * Exports blocks into a simplified HTML string. To better conform to HTML standards, children of blocks which aren't list
   * items are un-nested in the output HTML.
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToHTMLLossy(e = this.editor.document) {
    return be(
      this.editor.pmSchema,
      this.editor
    ).exportBlocks(e, {});
  }
  /**
   * Serializes blocks into an HTML string in the format that would normally be rendered by the editor.
   *
   * Use this method if you want to server-side render HTML (for example, a blog post that has been edited in BlockNote)
   * and serve it to users without loading the editor on the client (i.e.: displaying the blog post)
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToFullHTML(e = this.editor.document) {
    return Qt(
      this.editor.pmSchema,
      this.editor
    ).serializeBlocks(e, {});
  }
  /**
   * Parses blocks from an HTML string. Tries to create `Block` objects out of any HTML block-level elements, and
   * `InlineNode` objects from any HTML inline elements, though not all element types are recognized. If BlockNote
   * doesn't recognize an HTML element's tag, it will parse it as a paragraph or plain text.
   * @param html The HTML string to parse blocks from.
   * @returns The blocks parsed from the HTML string.
   */
  tryParseHTMLToBlocks(e) {
    return Te(e, this.editor.pmSchema);
  }
  /**
   * Serializes blocks into a Markdown string. The output is simplified as Markdown does not support all features of
   * BlockNote - children of blocks which aren't list items are un-nested and certain styles are removed.
   * @param blocks An array of blocks that should be serialized into Markdown.
   * @returns The blocks, serialized as a Markdown string.
   */
  blocksToMarkdownLossy(e = this.editor.document) {
    return ot(e, this.editor.pmSchema, this.editor, {});
  }
  /**
   * Creates a list of blocks from a Markdown string. Tries to create `Block` and `InlineNode` objects based on
   * Markdown syntax, though not all symbols are recognized. If BlockNote doesn't recognize a symbol, it will parse it
   * as text.
   * @param markdown The Markdown string to parse blocks from.
   * @returns The blocks parsed from the Markdown string.
   */
  tryParseMarkdownToBlocks(e) {
    return Bo(e, this.editor.pmSchema);
  }
  /**
   * Paste HTML into the editor. Defaults to converting HTML to BlockNote HTML.
   * @param html The HTML to paste.
   * @param raw Whether to paste the HTML as is, or to convert it to BlockNote HTML.
   */
  pasteHTML(e, t = !1) {
    var s;
    let o = e;
    if (!t) {
      const i = this.tryParseHTMLToBlocks(e);
      o = this.blocksToFullHTML(i);
    }
    o && ((s = this.editor.prosemirrorView) == null || s.pasteHTML(o));
  }
  /**
   * Paste text into the editor. Defaults to interpreting text as markdown.
   * @param text The text to paste.
   */
  pasteText(e) {
    var t;
    return (t = this.editor.prosemirrorView) == null ? void 0 : t.pasteText(e);
  }
  /**
   * Paste markdown into the editor.
   * @param markdown The markdown to paste.
   */
  pasteMarkdown(e) {
    const t = Pe(e);
    return this.pasteHTML(t);
  }
}
const oe = [
  "vscode-editor-data",
  "blocknote/html",
  "text/markdown",
  "text/html",
  "text/plain",
  "Files"
];
function Eo(n, e) {
  if (!n.startsWith(".") || !e.startsWith("."))
    throw new Error("The strings provided are not valid file extensions.");
  return n === e;
}
function xo(n, e) {
  const t = n.split("/"), o = e.split("/");
  if (t.length !== 2)
    throw new Error(`The string ${n} is not a valid MIME type.`);
  if (o.length !== 2)
    throw new Error(`The string ${e} is not a valid MIME type.`);
  return t[1] === "*" || o[1] === "*" ? t[0] === o[0] : (t[0] === "*" || o[0] === "*" || t[0] === o[0]) && t[1] === o[1];
}
function le(n, e, t, o = "after") {
  let s;
  return Array.isArray(e.content) && e.content.length === 0 ? s = n.updateBlock(e, t).id : s = n.insertBlocks(
    [t],
    e,
    o
  )[0].id, s;
}
async function ve(n, e) {
  var i;
  if (!e.uploadFile) {
    console.warn(
      "Attempted ot insert file, but uploadFile is not set in the BlockNote editor options"
    );
    return;
  }
  const t = "dataTransfer" in n ? n.dataTransfer : n.clipboardData;
  if (t === null)
    return;
  let o = null;
  for (const r of oe)
    if (t.types.includes(r)) {
      o = r;
      break;
    }
  if (o !== "Files")
    return;
  const s = t.items;
  if (s) {
    n.preventDefault();
    for (let r = 0; r < s.length; r++) {
      let c = "file";
      for (const l of Object.values(e.schema.blockSpecs))
        for (const d of ((i = l.implementation.meta) == null ? void 0 : i.fileBlockAccept) || []) {
          const u = d.startsWith("."), p = s[r].getAsFile();
          if (p && (!u && p.type && xo(s[r].type, d) || u && Eo(
            "." + p.name.split(".").pop(),
            d
          ))) {
            c = l.config.type;
            break;
          }
        }
      const a = s[r].getAsFile();
      if (a) {
        const l = {
          type: c,
          props: {
            name: a.name
          }
        };
        let d;
        if (n.type === "paste") {
          const m = e.getTextCursorPosition().block;
          d = le(e, m, l);
        } else if (n.type === "drop") {
          const m = {
            left: n.clientX,
            top: n.clientY
          }, f = e.prosemirrorView.posAtCoords(m);
          if (!f)
            return;
          d = e.transact((k) => {
            const g = _(k.doc, f.pos), y = e.prosemirrorView.dom.querySelector(
              `[data-id="${g.node.attrs.id}"]`
            ), T = y == null ? void 0 : y.getBoundingClientRect();
            return le(
              e,
              e.getBlock(g.node.attrs.id),
              l,
              T && (T.top + T.bottom) / 2 > m.top ? "before" : "after"
            );
          });
        } else
          return;
        const u = await e.uploadFile(a, d), p = typeof u == "string" ? {
          props: {
            url: u
          }
        } : { ...u };
        e.updateBlock(d, p);
      }
    }
  }
}
const Mo = (n) => x.create({
  name: "dropFile",
  addProseMirrorPlugins() {
    return [
      new ee({
        props: {
          handleDOMEvents: {
            drop(e, t) {
              if (!n.isEditable)
                return;
              let o = null;
              for (const s of oe)
                if (t.dataTransfer.types.includes(s)) {
                  o = s;
                  break;
                }
              return o === null ? !0 : o === "Files" ? (ve(t, n), !0) : !1;
            }
          }
        }
      })
    ];
  }
}), wo = /(^|\n) {0,3}#{1,6} {1,8}[^\n]{1,64}\r?\n\r?\n\s{0,32}\S/, To = /(_|__|\*|\*\*|~~|==|\+\+)(?!\s)(?:[^\s](?:.{0,62}[^\s])?|\S)(?=\1)/, Po = /\[[^\]]{1,128}\]\(https?:\/\/\S{1,999}\)/, vo = /(?:\s|^)`(?!\s)(?:[^\s`](?:[^`]{0,46}[^\s`])?|[^\s`])`([^\w]|$)/, Io = /(?:^|\n)\s{0,5}-\s{1}[^\n]+\n\s{0,15}-\s/, Ao = /(?:^|\n)\s{0,5}\d+\.\s{1}[^\n]+\n\s{0,15}\d+\.\s/, _o = /\n{2} {0,3}-{2,48}\n{2}/, Do = /(?:\n|^)(```|~~~|\$\$)(?!`|~)[^\s]{0,64} {0,64}[^\n]{0,64}\n[\s\S]{0,9999}?\s*\1 {0,64}(?:\n+|$)/, Lo = /(?:\n|^)(?!\s)\w[^\n]{0,64}\r?\n(-|=)\1{0,64}\n\n\s{0,64}(\w|$)/, No = /(?:^|(\r?\n\r?\n))( {0,3}>[^\n]{1,333}\n){1,999}($|(\r?\n))/, Oo = /^\s*\|(.+\|)+\s*$/m, Fo = /^\s*\|(\s*[-:]+[-:]\s*\|)+\s*$/m, Ho = /^\s*\|(.+\|)+\s*$/m, $o = (n) => wo.test(n) || To.test(n) || Po.test(n) || vo.test(n) || Io.test(n) || Ao.test(n) || _o.test(n) || Do.test(n) || Lo.test(n) || No.test(n) || Oo.test(n) || Fo.test(n) || Ho.test(n);
async function Vo(n, e) {
  const { schema: t } = e.state;
  if (!n.clipboardData)
    return !1;
  const o = n.clipboardData.getData("text/plain");
  if (!o)
    return !1;
  if (!t.nodes.codeBlock)
    return e.pasteText(o), !0;
  const s = n.clipboardData.getData("vscode-editor-data"), i = s ? JSON.parse(s) : void 0, r = i == null ? void 0 : i.mode;
  return r ? (e.pasteHTML(
    `<pre><code class="language-${r}">${o.replace(
      /\r\n?/g,
      `
`
    )}</code></pre>`
  ), !0) : !1;
}
function Uo({
  event: n,
  editor: e,
  prioritizeMarkdownOverHTML: t,
  plainTextAsMarkdown: o
}) {
  var c;
  if (e.transact(
    (a) => a.selection.$from.parent.type.spec.code && a.selection.$to.parent.type.spec.code
  )) {
    const a = (c = n.clipboardData) == null ? void 0 : c.getData("text/plain");
    if (a)
      return e.pasteText(a), !0;
  }
  let i;
  for (const a of oe)
    if (n.clipboardData.types.includes(a)) {
      i = a;
      break;
    }
  if (!i)
    return !0;
  if (i === "vscode-editor-data")
    return Vo(n, e.prosemirrorView), !0;
  if (i === "Files")
    return ve(n, e), !0;
  const r = n.clipboardData.getData(i);
  if (i === "blocknote/html")
    return e.pasteHTML(r, !0), !0;
  if (i === "text/markdown")
    return e.pasteMarkdown(r), !0;
  if (t) {
    const a = n.clipboardData.getData("text/plain");
    if ($o(a))
      return e.pasteMarkdown(a), !0;
  }
  return i === "text/html" ? (e.pasteHTML(r), !0) : o ? (e.pasteMarkdown(r), !0) : (e.pasteText(r), !0);
}
const zo = (n, e) => x.create({
  name: "pasteFromClipboard",
  addProseMirrorPlugins() {
    return [
      new ee({
        props: {
          handleDOMEvents: {
            paste(t, o) {
              if (o.preventDefault(), !!n.isEditable)
                return e({
                  event: o,
                  editor: n,
                  defaultPasteHandler: ({
                    prioritizeMarkdownOverHTML: s = !0,
                    plainTextAsMarkdown: i = !0
                  } = {}) => Uo({
                    event: o,
                    editor: n,
                    prioritizeMarkdownOverHTML: s,
                    plainTextAsMarkdown: i
                  })
                });
            }
          }
        }
      })
    ];
  }
});
function Go(n, e, t) {
  var c;
  let o = !1;
  const s = n.state.selection instanceof te;
  if (!s) {
    const a = n.state.doc.slice(
      n.state.selection.from,
      n.state.selection.to,
      !1
    ).content, l = [];
    for (let d = 0; d < a.childCount; d++)
      l.push(a.child(d));
    o = l.find(
      (d) => d.type.isInGroup("bnBlock") || d.type.name === "blockGroup" || d.type.spec.group === "blockContent"
    ) === void 0, o && (e = a);
  }
  let i;
  const r = be(
    n.state.schema,
    t
  );
  if (s) {
    ((c = e.firstChild) == null ? void 0 : c.type.name) === "table" && (e = e.firstChild.content);
    const a = ze(
      e,
      t.schema.inlineContentSchema,
      t.schema.styleSchema
    );
    i = `<table>${r.exportInlineContent(
      a,
      {}
    )}</table>`;
  } else if (o) {
    const a = Ge(
      e,
      t.schema.inlineContentSchema,
      t.schema.styleSchema
    );
    i = r.exportInlineContent(a, {});
  } else {
    const a = st(e);
    i = r.exportBlocks(a, {});
  }
  return i;
}
function Ie(n, e) {
  "node" in n.state.selection && n.state.selection.node.type.spec.group === "blockContent" && e.transact(
    (r) => r.setSelection(
      new L(r.doc.resolve(n.state.selection.from - 1))
    )
  );
  const t = n.serializeForClipboard(
    n.state.selection.content()
  ).dom.innerHTML, o = n.state.selection.content().content, s = Go(
    n,
    o,
    e
  ), i = nt(s);
  return { clipboardHTML: t, externalHTML: s, markdown: i };
}
const de = () => {
  const n = window.getSelection();
  if (!n || n.isCollapsed)
    return !0;
  let e = n.focusNode;
  for (; e; ) {
    if (e instanceof HTMLElement && e.getAttribute("contenteditable") === "false")
      return !0;
    e = e.parentElement;
  }
  return !1;
}, ue = (n, e, t) => {
  t.preventDefault(), t.clipboardData.clearData();
  const { clipboardHTML: o, externalHTML: s, markdown: i } = Ie(
    e,
    n
  );
  t.clipboardData.setData("blocknote/html", o), t.clipboardData.setData("text/html", s), t.clipboardData.setData("text/plain", i);
}, Ro = (n) => x.create({
  name: "copyToClipboard",
  addProseMirrorPlugins() {
    return [
      new ee({
        props: {
          handleDOMEvents: {
            copy(e, t) {
              return de() || ue(n, e, t), !0;
            },
            cut(e, t) {
              return de() || (ue(n, e, t), e.editable && e.dispatch(e.state.tr.deleteSelection())), !0;
            },
            // This is for the use-case in which only a block without content
            // is selected, e.g. an image block, and dragged (not using the
            // drag handle).
            dragstart(e, t) {
              if (!("node" in e.state.selection) || e.state.selection.node.type.spec.group !== "blockContent")
                return;
              n.transact(
                (r) => r.setSelection(
                  new L(
                    r.doc.resolve(e.state.selection.from - 1)
                  )
                )
              ), t.preventDefault(), t.dataTransfer.clearData();
              const { clipboardHTML: o, externalHTML: s, markdown: i } = Ie(e, n);
              return t.dataTransfer.setData("blocknote/html", o), t.dataTransfer.setData("text/html", s), t.dataTransfer.setData("text/plain", i), !0;
            }
          }
        }
      })
    ];
  }
}), jo = x.create({
  name: "blockBackgroundColor",
  addGlobalAttributes() {
    return [
      {
        types: ["tableCell", "tableHeader"],
        attributes: {
          backgroundColor: qe()
        }
      }
    ];
  }
}), Wo = D.create({
  name: "hardBreak",
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  priority: 10,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", xt(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  }
}), J = (n, e) => {
  const t = n.resolve(e), o = t.index();
  if (o === 0)
    return;
  const s = t.posAtIndex(o - 1);
  return q(
    n.resolve(s)
  );
}, Ae = (n, e) => {
  for (; e.childContainer; ) {
    const t = e.childContainer.node, o = n.resolve(e.childContainer.beforePos + 1).posAtIndex(t.childCount - 1);
    e = q(n.resolve(o));
  }
  return e;
}, Ko = (n, e) => n.isBlockContainer && n.blockContent.node.type.spec.content === "inline*" && n.blockContent.node.childCount > 0 && e.isBlockContainer && e.blockContent.node.type.spec.content === "inline*", Jo = (n, e, t, o) => {
  if (!o.isBlockContainer)
    throw new Error(
      `Attempted to merge block at position ${o.bnBlock.beforePos} into previous block at position ${t.bnBlock.beforePos}, but next block is not a block container`
    );
  if (o.childContainer) {
    const s = n.doc.resolve(
      o.childContainer.beforePos + 1
    ), i = n.doc.resolve(
      o.childContainer.afterPos - 1
    ), r = s.blockRange(i);
    if (e) {
      const c = n.doc.resolve(o.bnBlock.beforePos);
      n.tr.lift(r, c.depth);
    }
  }
  if (e) {
    if (!t.isBlockContainer)
      throw new Error(
        `Attempted to merge block at position ${o.bnBlock.beforePos} into previous block at position ${t.bnBlock.beforePos}, but previous block is not a block container`
      );
    e(
      n.tr.delete(
        t.blockContent.afterPos - 1,
        o.blockContent.beforePos + 1
      )
    );
  }
  return !0;
}, pe = (n) => ({
  state: e,
  dispatch: t
}) => {
  const o = e.doc.resolve(n), s = q(o), i = J(
    e.doc,
    s.bnBlock.beforePos
  );
  if (!i)
    return !1;
  const r = Ae(
    e.doc,
    i
  );
  return Ko(r, s) ? Jo(e, t, r, s) : !1;
}, Yo = x.create({
  priority: 50,
  // TODO: The shortcuts need a refactor. Do we want to use a command priority
  //  design as there is now, or clump the logic into a single function?
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ chain: o, commands: s }) => [
      // Deletes the selection if it's not empty.
      () => s.deleteSelection(),
      // Undoes an input rule if one was triggered in the last editor state change.
      () => s.undoInputRule(),
      // Reverts block content type to a paragraph if the selection is at the start of the block.
      () => s.command(({ state: i }) => {
        const r = S(i);
        if (!r.isBlockContainer)
          return !1;
        const c = i.selection.from === r.blockContent.beforePos + 1, a = r.blockContent.node.type.name === "paragraph";
        return c && !a ? s.command(
          Xe(r.bnBlock.beforePos, {
            type: "paragraph",
            props: {}
          })
        ) : !1;
      }),
      // Removes a level of nesting if the block is indented if the selection is at the start of the block.
      () => s.command(({ state: i }) => {
        const r = S(i);
        if (!r.isBlockContainer)
          return !1;
        const { blockContent: c } = r;
        return i.selection.from === c.beforePos + 1 ? s.liftListItem("blockContainer") : !1;
      }),
      // Merges block with the previous one if it isn't indented, and the selection is at the start of the
      // block. The target block for merging must contain inline content.
      () => s.command(({ state: i }) => {
        const r = S(i);
        if (!r.isBlockContainer)
          return !1;
        const { bnBlock: c, blockContent: a } = r, l = i.selection.from === a.beforePos + 1, d = i.selection.empty, u = c.beforePos;
        return l && d ? o().command(pe(u)).scrollIntoView().run() : !1;
      }),
      () => s.command(({ state: i, tr: r, dispatch: c }) => {
        const a = S(i);
        if (!a.isBlockContainer || !(r.selection.from === a.blockContent.beforePos + 1))
          return !1;
        const d = r.doc.resolve(a.bnBlock.beforePos);
        if (d.nodeBefore || d.node().type.name !== "column")
          return !1;
        const m = r.doc.resolve(a.bnBlock.beforePos), f = r.doc.resolve(m.before()), k = f.before();
        if (c) {
          const g = r.doc.slice(
            a.bnBlock.beforePos,
            a.bnBlock.afterPos
          ).content;
          r.delete(
            a.bnBlock.beforePos,
            a.bnBlock.afterPos
          ), f.index() === 0 ? (W(r, k), r.insert(k, g), r.setSelection(
            M.near(r.doc.resolve(k))
          )) : (r.insert(f.pos - 1, g), r.setSelection(
            M.near(r.doc.resolve(f.pos - 1))
          ), W(r, k));
        }
        return !0;
      }),
      // Deletes the current block if it's an empty block with inline content,
      // and moves the selection to the previous block.
      () => s.command(({ state: i }) => {
        const r = S(i);
        if (!r.isBlockContainer)
          return !1;
        if (r.blockContent.node.childCount === 0 && r.blockContent.node.type.spec.content === "inline*") {
          const a = J(
            i.doc,
            r.bnBlock.beforePos
          );
          if (!a || !a.isBlockContainer)
            return !1;
          let l = o();
          if (a.blockContent.node.type.spec.content === "tableRow+") {
            const f = r.bnBlock.beforePos - 1 - 1 - 1 - 1 - 1;
            l = l.setTextSelection(
              f
            );
          } else if (a.blockContent.node.type.spec.content === "") {
            const d = a.blockContent.afterPos - a.blockContent.node.nodeSize;
            l = l.setNodeSelection(
              d
            );
          } else {
            const d = a.blockContent.afterPos - a.blockContent.node.nodeSize;
            l = l.setTextSelection(d);
          }
          return l.deleteRange({
            from: r.bnBlock.beforePos,
            to: r.bnBlock.afterPos
          }).scrollIntoView().run();
        }
        return !1;
      }),
      // Deletes previous block if it contains no content and isn't a table,
      // when the selection is empty and at the start of the block. Moves the
      // current block into the deleted block's place.
      () => s.command(({ state: i }) => {
        const r = S(i);
        if (!r.isBlockContainer)
          throw new Error("todo");
        const c = i.selection.from === r.blockContent.beforePos + 1, a = i.selection.empty, l = J(
          i.doc,
          r.bnBlock.beforePos
        );
        if (l && c && a) {
          const d = Ae(
            i.doc,
            l
          );
          if (!d.isBlockContainer)
            throw new Error("todo");
          if (d.blockContent.node.type.spec.content === "" || d.blockContent.node.type.spec.content === "inline*" && d.blockContent.node.childCount === 0)
            return o().cut(
              {
                from: r.bnBlock.beforePos,
                to: r.bnBlock.afterPos
              },
              d.bnBlock.afterPos
            ).deleteRange({
              from: d.bnBlock.beforePos,
              to: d.bnBlock.afterPos
            }).run();
        }
        return !1;
      })
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      // Deletes the selection if it's not empty.
      () => o.deleteSelection(),
      // Merges block with the next one (at the same nesting level or lower),
      // if one exists, the block has no children, and the selection is at the
      // end of the block.
      () => o.command(({ state: s }) => {
        const i = S(s);
        if (!i.isBlockContainer)
          return !1;
        const {
          bnBlock: r,
          blockContent: c,
          childContainer: a
        } = i, { depth: l } = s.doc.resolve(r.beforePos), d = r.afterPos === s.doc.nodeSize - 3, u = s.selection.from === c.afterPos - 1, p = s.selection.empty;
        if (!d && u && p && !(a !== void 0)) {
          let f = l, k = r.afterPos + 1, g = s.doc.resolve(k).depth;
          for (; g < f; )
            f = g, k += 2, g = s.doc.resolve(k).depth;
          return o.command(pe(k - 1));
        }
        return !1;
      })
    ]), t = (o = !1) => this.editor.commands.first(({ commands: s, tr: i }) => [
      // Removes a level of nesting if the block is empty & indented, while the selection is also empty & at the start
      // of the block.
      () => s.command(({ state: r }) => {
        const c = S(r);
        if (!c.isBlockContainer)
          return !1;
        const { bnBlock: a, blockContent: l } = c, { depth: d } = r.doc.resolve(a.beforePos), u = r.selection.$anchor.parentOffset === 0, p = r.selection.anchor === r.selection.head, m = l.node.childCount === 0, f = d > 1;
        return u && p && m && f ? s.liftListItem("blockContainer") : !1;
      }),
      // Creates a hard break if block is configured to do so.
      () => s.command(({ state: r }) => {
        var l;
        const c = S(r), a = ((l = this.options.editor.schema.blockSchema[c.blockNoteType].meta) == null ? void 0 : l.hardBreakShortcut) ?? "shift+enter";
        if (a === "none")
          return !1;
        if (
          // If shortcut is not configured, or is configured as "shift+enter",
          // create a hard break for shift+enter, but not for enter.
          a === "shift+enter" && o || // If shortcut is configured as "enter", create a hard break for
          // both enter and shift+enter.
          a === "enter"
        ) {
          const d = i.storedMarks || i.selection.$head.marks().filter(
            (u) => this.editor.extensionManager.splittableMarks.includes(
              u.type.name
            )
          );
          return i.insert(
            i.selection.head,
            i.doc.type.schema.nodes.hardBreak.create()
          ).ensureMarks(d), !0;
        }
        return !1;
      }),
      // Creates a new block and moves the selection to it if the current one is empty, while the selection is also
      // empty & at the start of the block.
      () => s.command(({ state: r, dispatch: c }) => {
        const a = S(r);
        if (!a.isBlockContainer)
          return !1;
        const { bnBlock: l, blockContent: d } = a, u = r.selection.$anchor.parentOffset === 0, p = r.selection.anchor === r.selection.head, m = d.node.childCount === 0;
        if (u && p && m) {
          const f = l.afterPos, k = f + 2;
          if (c) {
            const g = r.schema.nodes.blockContainer.createAndFill();
            r.tr.insert(f, g).scrollIntoView(), r.tr.setSelection(
              new M(r.doc.resolve(k))
            );
          }
          return !0;
        }
        return !1;
      }),
      // Splits the current block, moving content inside that's after the cursor to a new text block below. Also
      // deletes the selection beforehand, if it's not empty.
      () => s.command(({ state: r, chain: c }) => {
        const a = S(r);
        if (!a.isBlockContainer)
          return !1;
        const { blockContent: l } = a, d = r.selection.$anchor.parentOffset === 0;
        return l.node.childCount === 0 ? !1 : (c().deleteSelection().command(
          Qe(
            r.selection.from,
            d,
            d
          )
        ).run(), !0);
      })
    ]);
    return {
      Backspace: n,
      Delete: e,
      Enter: () => t(),
      "Shift-Enter": () => t(!0),
      // Always returning true for tab key presses ensures they're not captured by the browser. Otherwise, they blur the
      // editor since the browser will try to use tab for keyboard navigation.
      Tab: () => {
        var o, s;
        return this.options.tabBehavior !== "prefer-indent" && ((o = this.options.editor.getExtension(R)) != null && o.store.state || ((s = this.options.editor.getExtension(G)) == null ? void 0 : s.store.state) !== void 0) ? !1 : we(this.options.editor);
      },
      "Shift-Tab": () => {
        var o, s;
        return this.options.tabBehavior !== "prefer-indent" && ((o = this.options.editor.getExtension(R)) != null && o.store.state || ((s = this.options.editor.getExtension(G)) == null ? void 0 : s.store.state) !== void 0) ? !1 : this.editor.commands.liftListItem("blockContainer");
      },
      "Shift-Mod-ArrowUp": () => (this.options.editor.moveBlocksUp(), !0),
      "Shift-Mod-ArrowDown": () => (this.options.editor.moveBlocksDown(), !0),
      "Mod-z": () => this.options.editor.undo(),
      "Mod-y": () => this.options.editor.redo(),
      "Shift-Mod-z": () => this.options.editor.redo()
    };
  }
}), qo = X.create({
  name: "insertion",
  inclusive: !1,
  excludes: "deletion modification insertion",
  addAttributes() {
    return {
      id: { default: null, validate: "number|null" }
      // note: validate is supported in prosemirror but not in tiptap, so this doesn't actually work (considered not critical)
    };
  },
  extendMarkSchema(n) {
    return n.name !== "insertion" ? {} : {
      blocknoteIgnore: !0,
      inclusive: !1,
      toDOM(e, t) {
        return [
          "ins",
          {
            "data-id": String(e.attrs.id),
            "data-inline": String(t),
            ...!t && { style: "display: contents" }
            // changed to "contents" to make this work for table rows
          },
          0
        ];
      },
      parseDOM: [
        {
          tag: "ins",
          getAttrs(e) {
            return e.dataset.id ? {
              id: parseInt(e.dataset.id, 10)
            } : !1;
          }
        }
      ]
    };
  }
}), Qo = X.create({
  name: "deletion",
  inclusive: !1,
  excludes: "insertion modification deletion",
  addAttributes() {
    return {
      id: { default: null, validate: "number|null" }
      // note: validate is supported in prosemirror but not in tiptap
    };
  },
  extendMarkSchema(n) {
    return n.name !== "deletion" ? {} : {
      blocknoteIgnore: !0,
      inclusive: !1,
      // attrs: {
      //   id: { validate: "number" },
      // },
      toDOM(e, t) {
        return [
          "del",
          {
            "data-id": String(e.attrs.id),
            "data-inline": String(t),
            ...!t && { style: "display: contents" }
            // changed to "contents" to make this work for table rows
          },
          0
        ];
      },
      parseDOM: [
        {
          tag: "del",
          getAttrs(e) {
            return e.dataset.id ? {
              id: parseInt(e.dataset.id, 10)
            } : !1;
          }
        }
      ]
    };
  }
}), Xo = X.create({
  name: "modification",
  inclusive: !1,
  excludes: "deletion insertion",
  addAttributes() {
    return {
      id: { default: null, validate: "number" },
      type: { validate: "string" },
      attrName: { default: null, validate: "string|null" },
      previousValue: { default: null },
      newValue: { default: null }
    };
  },
  extendMarkSchema(n) {
    return n.name !== "modification" ? {} : {
      blocknoteIgnore: !0,
      inclusive: !1,
      // attrs: {
      //   id: { validate: "number" },
      //   type: { validate: "string" },
      //   attrName: { default: null, validate: "string|null" },
      //   previousValue: { default: null },
      //   newValue: { default: null },
      // },
      toDOM(e, t) {
        return [
          t ? "span" : "div",
          {
            "data-type": "modification",
            "data-id": String(e.attrs.id),
            "data-mod-type": e.attrs.type,
            "data-mod-prev-val": JSON.stringify(e.attrs.previousValue),
            // TODO: Try to serialize marks with toJSON?
            "data-mod-new-val": JSON.stringify(e.attrs.newValue)
          },
          0
        ];
      },
      parseDOM: [
        {
          tag: "span[data-type='modification']",
          getAttrs(e) {
            return e.dataset.id ? {
              id: parseInt(e.dataset.id, 10),
              type: e.dataset.modType,
              previousValue: e.dataset.modPrevVal,
              newValue: e.dataset.modNewVal
            } : !1;
          }
        },
        {
          tag: "div[data-type='modification']",
          getAttrs(e) {
            return e.dataset.id ? {
              id: parseInt(e.dataset.id, 10),
              type: e.dataset.modType,
              previousValue: e.dataset.modPrevVal
            } : !1;
          }
        }
      ]
    };
  }
}), Zo = x.create({
  name: "textAlignment",
  addGlobalAttributes() {
    return [
      {
        // Generally text alignment is handled through props using the custom
        // blocks API. Tables are the only blocks that are created as TipTap
        // nodes and ported to blocks, so we need to add text alignment in a
        // separate extension.
        types: ["tableCell", "tableHeader"],
        attributes: {
          textAlignment: {
            default: "left",
            parseHTML: (n) => n.getAttribute("data-text-alignment"),
            renderHTML: (n) => n.textAlignment === "left" ? {} : {
              "data-text-alignment": n.textAlignment
            }
          }
        }
      }
    ];
  }
}), en = x.create({
  name: "blockTextColor",
  addGlobalAttributes() {
    return [
      {
        types: ["table", "tableCell", "tableHeader"],
        attributes: {
          textColor: Ze()
        }
      }
    ];
  }
}), tn = {
  blockColor: "data-block-color",
  blockStyle: "data-block-style",
  id: "data-id",
  depth: "data-depth",
  depthChange: "data-depth-change"
}, on = D.create({
  name: "blockContainer",
  group: "blockGroupChild bnBlock",
  // A block always contains content, and optionally a blockGroup which contains nested blocks
  content: "blockContent blockGroup?",
  // Ensures content-specific keyboard handlers trigger first.
  priority: 50,
  defining: !0,
  marks: "insertion modification deletion",
  parseHTML() {
    return [
      {
        tag: "div[data-node-type=" + this.name + "]",
        getAttrs: (n) => {
          if (typeof n == "string")
            return !1;
          const e = {};
          for (const [t, o] of Object.entries(tn))
            n.getAttribute(o) && (e[t] = n.getAttribute(o));
          return e;
        }
      },
      // Ignore `blockOuter` divs, but parse the `blockContainer` divs inside them.
      {
        tag: 'div[data-node-type="blockOuter"]',
        skip: !0
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    var s;
    const e = document.createElement("div");
    e.className = "bn-block-outer", e.setAttribute("data-node-type", "blockOuter");
    for (const [i, r] of Object.entries(n))
      i !== "class" && e.setAttribute(i, r);
    const t = {
      ...((s = this.options.domAttributes) == null ? void 0 : s.block) || {},
      ...n
    }, o = document.createElement("div");
    o.className = Q("bn-block", t.class), o.setAttribute("data-node-type", this.name);
    for (const [i, r] of Object.entries(t))
      i !== "class" && o.setAttribute(i, r);
    return e.appendChild(o), {
      dom: e,
      contentDOM: o
    };
  }
}), nn = D.create({
  name: "blockGroup",
  group: "childContainer",
  content: "blockGroupChild+",
  marks: "deletion insertion modification",
  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (n) => typeof n == "string" ? !1 : n.getAttribute("data-node-type") === "blockGroup" ? null : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    var o;
    const e = {
      ...((o = this.options.domAttributes) == null ? void 0 : o.blockGroup) || {},
      ...n
    }, t = document.createElement("div");
    t.className = Q(
      "bn-block-group",
      e.class
    ), t.setAttribute("data-node-type", "blockGroup");
    for (const [s, i] of Object.entries(e))
      s !== "class" && t.setAttribute(s, i);
    return {
      dom: t,
      contentDOM: t
    };
  }
}), sn = D.create({
  name: "doc",
  topNode: !0,
  content: "blockGroup",
  marks: "insertion modification deletion"
});
let fe = !1;
function rn(n, e) {
  const t = [
    I.ClipboardTextSerializer,
    I.Commands,
    I.Editable,
    I.FocusEvents,
    I.Tabindex,
    Ot,
    me.configure({
      // everything from bnBlock group (nodes that represent a BlockNote block should have an id)
      types: ["blockContainer", "columnList", "column"],
      setIdAttribute: e.setIdAttribute
    }),
    Wo,
    Ht,
    // marks:
    qo,
    Qo,
    Xo,
    Ft.extend({
      inclusive: !1
    }).configure({
      defaultProtocol: Bt,
      // only call this once if we have multiple editors installed. Or fix https://github.com/ueberdosis/tiptap/issues/5450
      protocols: fe ? [] : St
    }),
    ...Object.values(n.schema.styleSpecs).map((o) => o.implementation.mark.configure({
      editor: n
    })),
    en,
    jo,
    Zo,
    // make sure escape blurs editor, so that we can tab to other elements in the host page (accessibility)
    x.create({
      name: "OverrideEscape",
      addKeyboardShortcuts: () => ({
        Escape: () => {
          var o;
          return (o = n.getExtension(ge)) != null && o.shown() ? !1 : (n.blur(), !0);
        }
      })
    }),
    // nodes
    sn,
    on.configure({
      editor: n,
      domAttributes: e.domAttributes
    }),
    Yo.configure({
      editor: n,
      tabBehavior: e.tabBehavior
    }),
    nn.configure({
      domAttributes: e.domAttributes
    }),
    ...Object.values(n.schema.inlineContentSpecs).filter((o) => o.config !== "link" && o.config !== "text").map((o) => o.implementation.node.configure({
      editor: n
    })),
    ...Object.values(n.schema.blockSpecs).flatMap((o) => [
      // the node extension implementations
      ..."node" in o.implementation ? [
        o.implementation.node.configure({
          editor: n,
          domAttributes: e.domAttributes
        })
      ] : []
    ]),
    Ro(n),
    zo(
      n,
      e.pasteHandler || ((o) => o.defaultPasteHandler())
    ),
    Mo(n)
  ];
  return fe = !0, t;
}
function an(n, e) {
  var o;
  const t = [
    rt(),
    it(e),
    G(e),
    R(e),
    at(e),
    ct(),
    lt(e),
    $t(e),
    dt(e),
    ge(e),
    ...e.trailingBlock !== !1 ? [ut()] : []
  ];
  return e.collaboration ? (t.push(pt(e.collaboration)), (o = e.collaboration.provider) != null && o.awareness && t.push(ft(e.collaboration)), t.push(ht(e.collaboration)), t.push(mt(e.collaboration)), t.push(kt(e.collaboration))) : t.push(gt()), "table" in n.schema.blockSpecs && t.push(bt(e)), e.animations !== !1 && t.push(yt()), t;
}
class cn {
  constructor(e, t) {
    /**
     * A set of extension keys which are disabled by the options
     */
    h(this, "disabledExtensions", /* @__PURE__ */ new Set());
    /**
     * A list of all the extensions that are registered to the editor
     */
    h(this, "extensions", []);
    /**
     * A map of all the abort controllers for each extension that has an init method defined
     */
    h(this, "abortMap", /* @__PURE__ */ new Map());
    /**
     * A map of all the extension factories that are registered to the editor
     */
    h(this, "extensionFactories", /* @__PURE__ */ new Map());
    /**
     * Because a single blocknote extension can both have it's own prosemirror plugins & additional generated ones (e.g. keymap & input rules plugins)
     * We need to keep track of all the plugins for each extension, so that we can remove them when the extension is unregistered
     */
    h(this, "extensionPlugins", /* @__PURE__ */ new Map());
    this.editor = e, this.options = t, e.onMount(() => {
      for (const o of this.extensions)
        if (o.mount) {
          const s = new window.AbortController(), i = o.mount({
            dom: e.prosemirrorView.dom,
            root: e.prosemirrorView.root,
            signal: s.signal
          });
          i && s.signal.addEventListener("abort", () => {
            i();
          }), this.abortMap.set(o, s);
        }
    }), e.onUnmount(() => {
      for (const [o, s] of this.abortMap.entries())
        this.abortMap.delete(o), s.abort();
    }), this.disabledExtensions = new Set(t.disableExtensions || []);
    for (const o of an(this.editor, this.options))
      this.addExtension(o);
    for (const o of this.options.extensions ?? [])
      this.addExtension(o);
    for (const o of Object.values(this.editor.schema.blockSpecs))
      for (const s of o.extensions ?? [])
        this.addExtension(s);
  }
  /**
   * Register one or more extensions to the editor after the editor is initialized.
   *
   * This allows users to switch on & off extensions "at runtime".
   */
  registerExtension(e) {
    var i;
    const t = [].concat(e).filter(Boolean);
    if (!t.length) {
      console.warn("No extensions found to register", e);
      return;
    }
    const o = t.map((r) => this.addExtension(r)).filter(Boolean), s = /* @__PURE__ */ new Set();
    for (const r of o)
      r != null && r.tiptapExtensions && console.warn(
        `Extension ${r.key} has tiptap extensions, but these cannot be changed after initializing the editor. Please separate the extension into multiple extensions if you want to add them, or re-initialize the editor.`,
        r
      ), (i = r == null ? void 0 : r.inputRules) != null && i.length && console.warn(
        `Extension ${r.key} has input rules, but these cannot be changed after initializing the editor. Please separate the extension into multiple extensions if you want to add them, or re-initialize the editor.`,
        r
      ), this.getProsemirrorPluginsFromExtension(r).plugins.forEach(
        (c) => {
          s.add(c);
        }
      );
    this.updatePlugins((r) => [...r, ...s]);
  }
  /**
   * Register an extension to the editor
   * @param extension - The extension to register
   * @returns The extension instance
   */
  addExtension(e) {
    let t;
    if (typeof e == "function" ? t = e({ editor: this.editor }) : t = e, !(!t || this.disabledExtensions.has(t.key))) {
      if (typeof e == "function") {
        const o = t[Nt];
        typeof o == "function" && this.extensionFactories.set(o, t);
      }
      return this.extensions.push(t), t;
    }
  }
  /**
   * Resolve an extension or a list of extensions into a list of extension instances
   * @param toResolve - The extension or list of extensions to resolve
   * @returns A list of extension instances
   */
  resolveExtensions(e) {
    const t = [];
    if (typeof e == "function") {
      const o = this.extensionFactories.get(e);
      o && t.push(o);
    } else if (Array.isArray(e))
      for (const o of e)
        t.push(...this.resolveExtensions(o));
    else if (typeof e == "object" && "key" in e)
      t.push(e);
    else if (typeof e == "string") {
      const o = this.extensions.find((s) => s.key === e);
      o && t.push(o);
    }
    return t;
  }
  /**
   * Unregister an extension from the editor
   * @param toUnregister - The extension to unregister
   * @returns void
   */
  unregisterExtension(e) {
    var i;
    const t = this.resolveExtensions(e);
    if (!t.length) {
      console.warn("No extensions found to unregister", e);
      return;
    }
    let o = !1;
    const s = /* @__PURE__ */ new Set();
    for (const r of t) {
      this.extensions = this.extensions.filter((a) => a !== r), this.extensionFactories.forEach((a, l) => {
        a === r && this.extensionFactories.delete(l);
      }), (i = this.abortMap.get(r)) == null || i.abort(), this.abortMap.delete(r);
      const c = this.extensionPlugins.get(r);
      c == null || c.forEach((a) => {
        s.add(a);
      }), this.extensionPlugins.delete(r), r.tiptapExtensions && !o && (o = !0, console.warn(
        `Extension ${r.key} has tiptap extensions, but they will not be removed. Please separate the extension into multiple extensions if you want to remove them, or re-initialize the editor.`,
        e
      ));
    }
    this.updatePlugins(
      (r) => r.filter((c) => !s.has(c))
    );
  }
  /**
   * Allows resetting the current prosemirror state's plugins
   * @param update - A function that takes the current plugins and returns the new plugins
   * @returns void
   */
  updatePlugins(e) {
    const t = this.editor.prosemirrorState, o = t.reconfigure({
      plugins: e(t.plugins.slice())
    });
    this.editor.prosemirrorView.updateState(o);
  }
  /**
   * Get all the extensions that are registered to the editor
   */
  getTiptapExtensions() {
    var s;
    const e = rn(
      this.editor,
      this.options
    ), t = Ct(this.extensions), o = /* @__PURE__ */ new Map();
    for (const i of this.extensions) {
      i.tiptapExtensions && e.push(...i.tiptapExtensions);
      const r = t(i.key), { plugins: c, inputRules: a } = this.getProsemirrorPluginsFromExtension(i);
      c.length && e.push(
        x.create({
          name: i.key,
          priority: r,
          addProseMirrorPlugins: () => c
        })
      ), a.length && (o.has(r) || o.set(r, []), o.get(r).push(...a));
    }
    e.push(
      x.create({
        name: "blocknote-input-rules",
        addProseMirrorPlugins() {
          const i = [];
          return Array.from(o.keys()).sort().reverse().forEach((r) => {
            i.push(...o.get(r));
          }), [_t({ rules: i })];
        }
      })
    );
    for (const i of ((s = this.options._tiptapOptions) == null ? void 0 : s.extensions) ?? [])
      e.push(i);
    return e;
  }
  /**
   * This maps a blocknote extension into an array of Prosemirror plugins if it has any of the following:
   * - plugins
   * - keyboard shortcuts
   * - input rules
   */
  getProsemirrorPluginsFromExtension(e) {
    var s, i, r;
    const t = [...e.prosemirrorPlugins ?? []], o = [];
    return !((s = e.prosemirrorPlugins) != null && s.length) && !Object.keys(e.keyboardShortcuts || {}).length && !((i = e.inputRules) != null && i.length) ? { plugins: t, inputRules: o } : (this.extensionPlugins.set(e, t), (r = e.inputRules) != null && r.length && o.push(
      ...e.inputRules.map((c) => new Dt(c.find, (a, l, d, u) => {
        const p = c.replace({
          match: l,
          range: { from: d, to: u },
          editor: this.editor
        });
        if (p) {
          const m = this.editor.getTextCursorPosition();
          if (this.editor.schema.blockSchema[m.block.type].content !== "inline")
            return null;
          const f = H(a.tr), k = a.tr.deleteRange(d, u);
          return et(k, f.bnBlock.beforePos, p), k;
        }
        return null;
      }))
    ), Object.keys(e.keyboardShortcuts || {}).length && t.push(
      Lt(
        Object.fromEntries(
          Object.entries(e.keyboardShortcuts).map(([c, a]) => [
            c,
            () => a({ editor: this.editor })
          ])
        )
      )
    ), { plugins: t, inputRules: o });
  }
  /**
   * Get all extensions
   */
  getExtensions() {
    return new Map(
      this.extensions.map((e) => [e.key, e])
    );
  }
  getExtension(e) {
    if (typeof e == "string") {
      const t = this.extensions.find((o) => o.key === e);
      return t || void 0;
    } else if (typeof e == "function") {
      const t = this.extensionFactories.get(e);
      return t || void 0;
    }
    throw new Error(`Invalid extension type: ${typeof e}`);
  }
  /**
   * Check if an extension exists
   */
  hasExtension(e) {
    return typeof e == "string" ? this.extensions.some((t) => t.key === e) : typeof e == "object" && "key" in e ? this.extensions.some((t) => t.key === e.key) : typeof e == "function" ? this.extensionFactories.has(e) : !1;
  }
}
function ln(n) {
  const e = B(n);
  if (n.selection.empty || "node" in n.selection)
    return;
  const t = n.doc.resolve(
    _(n.doc, n.selection.from).posBeforeNode
  ), o = n.doc.resolve(
    _(n.doc, n.selection.to).posBeforeNode
  ), s = (l, d) => {
    const u = t.posAtIndex(l, d), p = n.doc.resolve(u).nodeAfter;
    if (!p)
      throw new Error(
        `Error getting selection - node not found at position ${u}`
      );
    return b(p, e);
  }, i = [], r = t.sharedDepth(o.pos), c = t.index(r), a = o.index(r);
  if (t.depth > r) {
    i.push(b(t.nodeAfter, e));
    for (let l = t.depth; l > r; l--)
      if (t.node(l).type.isInGroup("childContainer")) {
        const u = t.index(l) + 1, p = t.node(l).childCount;
        for (let m = u; m < p; m++)
          i.push(s(m, l));
      }
  } else
    i.push(s(c, r));
  for (let l = c + 1; l <= a; l++)
    i.push(s(l, r));
  if (i.length === 0)
    throw new Error(
      `Error getting selection - selection doesn't span any blocks (${n.selection})`
    );
  return {
    blocks: i
  };
}
function dn(n, e, t) {
  const o = typeof e == "string" ? e : e.id, s = typeof t == "string" ? t : t.id, i = B(n), r = ke(i);
  if (o === s)
    throw new Error(
      `Attempting to set selection with the same anchor and head blocks (id ${o})`
    );
  const c = E(o, n.doc);
  if (!c)
    throw new Error(`Block with ID ${o} not found`);
  const a = E(s, n.doc);
  if (!a)
    throw new Error(`Block with ID ${s} not found`);
  const l = z(c), d = z(a), u = r.blockSchema[l.blockNoteType], p = r.blockSchema[d.blockNoteType];
  if (!l.isBlockContainer || u.content === "none")
    throw new Error(
      `Attempting to set selection anchor in block without content (id ${o})`
    );
  if (!d.isBlockContainer || p.content === "none")
    throw new Error(
      `Attempting to set selection anchor in block without content (id ${s})`
    );
  let m, f;
  if (u.content === "table") {
    const k = se.get(l.blockContent.node);
    m = l.blockContent.beforePos + k.positionAt(0, 0, l.blockContent.node) + 1 + 2;
  } else
    m = l.blockContent.beforePos + 1;
  if (p.content === "table") {
    const k = se.get(d.blockContent.node), g = d.blockContent.beforePos + k.positionAt(
      k.height - 1,
      k.width - 1,
      d.blockContent.node
    ) + 1, y = n.doc.resolve(g).nodeAfter.nodeSize;
    f = g + y - 2;
  } else
    f = d.blockContent.afterPos - 1;
  n.setSelection(M.create(n.doc, m, f));
}
function un(n) {
  const e = B(n);
  let t = n.selection.$from, o = n.selection.$to;
  for (; o.parentOffset >= o.parent.nodeSize - 2 && o.depth > 0; )
    o = n.doc.resolve(o.pos + 1);
  for (; o.parentOffset === 0 && o.depth > 0; )
    o = n.doc.resolve(o.pos - 1);
  for (; t.parentOffset === 0 && t.depth > 0; )
    t = n.doc.resolve(t.pos - 1);
  for (; t.parentOffset >= t.parent.nodeSize - 2 && t.depth > 0; )
    t = n.doc.resolve(t.pos + 1);
  const s = Re(
    n.doc.slice(t.pos, o.pos, !0),
    e
  );
  return {
    _meta: {
      startPos: t.pos,
      endPos: o.pos
    },
    ...s
  };
}
function pn(n) {
  const { bnBlock: e } = H(n), t = B(n.doc), o = n.doc.resolve(e.beforePos), s = o.nodeBefore, i = n.doc.resolve(e.afterPos).nodeAfter;
  let r;
  return o.depth > 1 && (r = o.node(), r.type.isInGroup("bnBlock") || (r = o.node(o.depth - 1))), {
    block: b(e.node, t),
    prevBlock: s === null ? void 0 : b(s, t),
    nextBlock: i === null ? void 0 : b(i, t),
    parentBlock: r === void 0 ? void 0 : b(r, t)
  };
}
function _e(n, e, t = "start") {
  const o = typeof e == "string" ? e : e.id, s = B(n.doc), i = ke(s), r = E(o, n.doc);
  if (!r)
    throw new Error(`Block with ID ${o} not found`);
  const c = z(r), a = i.blockSchema[c.blockNoteType].content;
  if (c.isBlockContainer) {
    const l = c.blockContent;
    if (a === "none") {
      n.setSelection(L.create(n.doc, l.beforePos));
      return;
    }
    if (a === "inline")
      t === "start" ? n.setSelection(
        M.create(n.doc, l.beforePos + 1)
      ) : n.setSelection(
        M.create(n.doc, l.afterPos - 1)
      );
    else if (a === "table")
      t === "start" ? n.setSelection(
        M.create(n.doc, l.beforePos + 4)
      ) : n.setSelection(
        M.create(n.doc, l.afterPos - 4)
      );
    else
      throw new F(a);
  } else {
    const l = t === "start" ? c.childContainer.node.firstChild : c.childContainer.node.lastChild;
    _e(n, l.attrs.id, t);
  }
}
class fn {
  constructor(e) {
    this.editor = e;
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned data will contain the entire block.
   */
  getSelection() {
    return this.editor.transact((e) => ln(e));
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned block will be
   * only the part of the block that is included in the selection.
   */
  getSelectionCutBlocks() {
    return this.editor.transact((e) => un(e));
  }
  /**
   * Sets the selection to a range of blocks.
   * @param startBlock The identifier of the block that should be the start of the selection.
   * @param endBlock The identifier of the block that should be the end of the selection.
   */
  setSelection(e, t) {
    return this.editor.transact((o) => dn(o, e, t));
  }
  /**
   * Gets a snapshot of the current text cursor position.
   * @returns A snapshot of the current text cursor position.
   */
  getTextCursorPosition() {
    return this.editor.transact((e) => pn(e));
  }
  /**
   * Sets the text cursor position to the start or end of an existing block. Throws an error if the target block could
   * not be found.
   * @param targetBlock The identifier of an existing block that the text cursor should be moved to.
   * @param placement Whether the text cursor should be placed at the start or end of the block.
   */
  setTextCursorPosition(e, t = "start") {
    return this.editor.transact(
      (o) => _e(o, e, t)
    );
  }
  /**
   * Gets the bounding box of the current selection.
   */
  getSelectionBoundingBox() {
    if (!this.editor.prosemirrorView)
      return;
    const { selection: e } = this.editor.prosemirrorState, { ranges: t } = e, o = Math.min(...t.map((i) => i.$from.pos)), s = Math.max(...t.map((i) => i.$to.pos));
    if (Mt(e)) {
      const i = this.editor.prosemirrorView.nodeDOM(o);
      if (i)
        return i.getBoundingClientRect();
    }
    return wt(
      this.editor.prosemirrorView,
      o,
      s
    ).toJSON();
  }
}
class hn {
  constructor(e) {
    /**
     * Stores the currently active transaction, which is the accumulated transaction from all {@link dispatch} calls during a {@link transact} calls
     */
    h(this, "activeTransaction", null);
    // Flag to indicate if we're in a `can` call
    h(this, "isInCan", !1);
    this.editor = e;
  }
  /**
   * For any command that can be executed, you can check if it can be executed by calling `editor.can(command)`.
   * @example
   * ```ts
   * if (editor.can(editor.undo)) {
   *   // show button
   * } else {
   *   // hide button
   * }
   */
  can(e) {
    try {
      return this.isInCan = !0, e();
    } finally {
      this.isInCan = !1;
    }
  }
  /**
   * Execute a prosemirror command. This is mostly for backwards compatibility with older code.
   *
   * @note You should prefer the {@link transact} method when possible, as it will automatically handle the dispatching of the transaction and work across blocknote transactions.
   *
   * @example
   * ```ts
   * editor.exec((state, dispatch, view) => {
   *   dispatch(state.tr.insertText("Hello, world!"));
   * });
   * ```
   */
  exec(e) {
    if (this.activeTransaction)
      throw new Error(
        "`exec` should not be called within a `transact` call, move the `exec` call outside of the `transact` call"
      );
    if (this.isInCan)
      return this.canExec(e);
    const t = this.prosemirrorState, o = this.prosemirrorView;
    return e(t, (i) => this.prosemirrorView.dispatch(i), o);
  }
  /**
   * Check if a command can be executed. A command should return `false` if it is not valid in the current state.
   *
   * @example
   * ```ts
   * if (editor.canExec(command)) {
   *   // show button
   * } else {
   *   // hide button
   * }
   * ```
   */
  canExec(e) {
    if (this.activeTransaction)
      throw new Error(
        "`canExec` should not be called within a `transact` call, move the `canExec` call outside of the `transact` call"
      );
    const t = this.prosemirrorState, o = this.prosemirrorView;
    return e(t, void 0, o);
  }
  /**
   * Execute a function within a "blocknote transaction".
   * All changes to the editor within the transaction will be grouped together, so that
   * we can dispatch them as a single operation (thus creating only a single undo step)
   *
   * @note There is no need to dispatch the transaction, as it will be automatically dispatched when the callback is complete.
   *
   * @example
   * ```ts
   * // All changes to the editor will be grouped together
   * editor.transact((tr) => {
   *   tr.insertText("Hello, world!");
   * // These two operations will be grouped together in a single undo step
   *   editor.transact((tr) => {
   *     tr.insertText("Hello, world!");
   *   });
   * });
   * ```
   */
  transact(e) {
    if (this.activeTransaction)
      return e(this.activeTransaction);
    try {
      this.activeTransaction = this.editor._tiptapEditor.state.tr;
      const t = e(this.activeTransaction), o = this.activeTransaction;
      return this.activeTransaction = null, o && // Only dispatch if the transaction was actually modified in some way
      (o.docChanged || o.selectionSet || o.scrolledIntoView || o.storedMarksSet || !o.isGeneric) && this.prosemirrorView.dispatch(o), t;
    } finally {
      this.activeTransaction = null;
    }
  }
  /**
   * Get the underlying prosemirror state
   * @note Prefer using `editor.transact` to read the current editor state, as that will ensure the state is up to date
   * @see https://prosemirror.net/docs/ref/#state.EditorState
   */
  get prosemirrorState() {
    if (this.activeTransaction)
      throw new Error(
        "`prosemirrorState` should not be called within a `transact` call, move the `prosemirrorState` call outside of the `transact` call or use `editor.transact` to read the current editor state"
      );
    return this.editor._tiptapEditor.state;
  }
  /**
   * Get the underlying prosemirror view
   * @see https://prosemirror.net/docs/ref/#view.EditorView
   */
  get prosemirrorView() {
    return this.editor._tiptapEditor.view;
  }
  isFocused() {
    var e;
    return ((e = this.prosemirrorView) == null ? void 0 : e.hasFocus()) || !1;
  }
  focus() {
    var e;
    (e = this.prosemirrorView) == null || e.focus();
  }
  /**
   * Checks if the editor is currently editable, or if it's locked.
   * @returns True if the editor is editable, false otherwise.
   */
  get isEditable() {
    if (!this.editor._tiptapEditor) {
      if (!this.editor.headless)
        throw new Error("no editor, but also not headless?");
      return !1;
    }
    return this.editor._tiptapEditor.isEditable === void 0 ? !0 : this.editor._tiptapEditor.isEditable;
  }
  /**
   * Makes the editor editable or locks it, depending on the argument passed.
   * @param editable True to make the editor editable, or false to lock it.
   */
  set isEditable(e) {
    if (!this.editor._tiptapEditor) {
      if (!this.editor.headless)
        throw new Error("no editor, but also not headless?");
      return;
    }
    this.editor._tiptapEditor.options.editable !== e && this.editor._tiptapEditor.setEditable(e);
  }
  /**
   * Undo the last action.
   */
  undo() {
    const e = this.editor.getExtension("yUndo");
    if (e)
      return this.exec(e.undoCommand);
    const t = this.editor.getExtension("history");
    if (t)
      return this.exec(t.undoCommand);
    throw new Error("No undo plugin found");
  }
  /**
   * Redo the last action.
   */
  redo() {
    const e = this.editor.getExtension("yUndo");
    if (e)
      return this.exec(e.redoCommand);
    const t = this.editor.getExtension("history");
    if (t)
      return this.exec(t.redoCommand);
    throw new Error("No redo plugin found");
  }
}
function mn(n, e, t, o = { updateSelection: !0 }) {
  let { from: s, to: i } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, r = !0, c = !0, a = "";
  if (t.forEach((l) => {
    l.check(), r && l.isText && l.marks.length === 0 ? a += l.text : r = !1, c = c ? l.isBlock : !1;
  }), s === i && c) {
    const { parent: l } = n.doc.resolve(s);
    l.isTextblock && !l.type.spec.code && !l.childCount && (s -= 1, i += 1);
  }
  return r ? n.insertText(a, s, i) : n.replaceWith(s, i, t), o.updateSelection && Tt(n, n.steps.length - 1, -1), !0;
}
class kn {
  constructor(e) {
    this.editor = e;
  }
  /**
   * Insert a piece of content at the current cursor position.
   *
   * @param content can be a string, or array of partial inline content elements
   */
  insertInlineContent(e, { updateSelection: t = !1 } = {}) {
    const o = O(e, this.editor.pmSchema);
    this.editor.transact((s) => {
      mn(
        s,
        {
          from: s.selection.from,
          to: s.selection.to
        },
        o,
        {
          updateSelection: t
        }
      );
    });
  }
  /**
   * Gets the active text styles at the text cursor position or at the end of the current selection if it's active.
   */
  getActiveStyles() {
    return this.editor.transact((e) => {
      const t = {}, o = e.selection.$to.marks();
      for (const s of o) {
        const i = this.editor.schema.styleSchema[s.type.name];
        if (!i) {
          // Links are not considered styles in blocknote
          s.type.name !== "link" && // "blocknoteIgnore" tagged marks (such as comments) are also not considered BlockNote "styles"
          !s.type.spec.blocknoteIgnore && console.warn("mark not found in styleschema", s.type.name);
          continue;
        }
        i.propSchema === "boolean" ? t[i.type] = !0 : t[i.type] = s.attrs.stringValue;
      }
      return t;
    });
  }
  /**
   * Adds styles to the currently selected content.
   * @param styles The styles to add.
   */
  addStyles(e) {
    for (const [t, o] of Object.entries(e)) {
      const s = this.editor.schema.styleSchema[t];
      if (!s)
        throw new Error(`style ${t} not found in styleSchema`);
      if (s.propSchema === "boolean")
        this.editor._tiptapEditor.commands.setMark(t);
      else if (s.propSchema === "string")
        this.editor._tiptapEditor.commands.setMark(t, {
          stringValue: o
        });
      else
        throw new F(s.propSchema);
    }
  }
  /**
   * Removes styles from the currently selected content.
   * @param styles The styles to remove.
   */
  removeStyles(e) {
    for (const t of Object.keys(e))
      this.editor._tiptapEditor.commands.unsetMark(t);
  }
  /**
   * Toggles styles on the currently selected content.
   * @param styles The styles to toggle.
   */
  toggleStyles(e) {
    for (const [t, o] of Object.entries(e)) {
      const s = this.editor.schema.styleSchema[t];
      if (!s)
        throw new Error(`style ${t} not found in styleSchema`);
      if (s.propSchema === "boolean")
        this.editor._tiptapEditor.commands.toggleMark(t);
      else if (s.propSchema === "string")
        this.editor._tiptapEditor.commands.toggleMark(t, {
          stringValue: o
        });
      else
        throw new F(s.propSchema);
    }
  }
  /**
   * Gets the currently selected text.
   */
  getSelectedText() {
    return this.editor.transact((e) => e.doc.textBetween(e.selection.from, e.selection.to));
  }
  /**
   * Gets the URL of the last link in the current selection, or `undefined` if there are no links in the selection.
   */
  getSelectedLinkUrl() {
    return this.editor._tiptapEditor.getAttributes("link").href;
  }
  /**
   * Creates a new link to replace the selected content.
   * @param url The link URL.
   * @param text The text to display the link with.
   */
  createLink(e, t) {
    if (e === "")
      return;
    const o = this.editor.pmSchema.mark("link", { href: e });
    this.editor.transact((s) => {
      const { from: i, to: r } = s.selection;
      t ? s.insertText(t, i, r).addMark(i, i + t.length, o) : s.setSelection(jt.create(s.doc, r)).addMark(
        i,
        r,
        o
      );
    });
  }
}
function gn(n, e) {
  const t = [];
  return n.forEach((o, s, i) => {
    i !== e && t.push(o);
  }), Z.from(t);
}
function bn(n, e) {
  const t = [];
  for (let o = 0; o < n.childCount; o++)
    if (n.child(o).type.name === "tableRow")
      if (t.length > 0 && t[t.length - 1].type.name === "table") {
        const s = t[t.length - 1], i = s.copy(s.content.addToEnd(n.child(o)));
        t[t.length - 1] = i;
      } else {
        const s = e.nodes.table.createChecked(
          void 0,
          n.child(o)
        );
        t.push(s);
      }
    else
      t.push(n.child(o));
  return n = Z.from(t), n;
}
function yn(n, e) {
  let t = Z.from(n.content);
  if (t = bn(t, e.state.schema), !Sn(t, e))
    return new ne(t, n.openStart, n.openEnd);
  for (let o = 0; o < t.childCount; o++)
    if (t.child(o).type.spec.group === "blockContent") {
      const s = [t.child(o)];
      if (o + 1 < t.childCount && t.child(o + 1).type.name === "blockGroup") {
        const r = t.child(o + 1).child(0).child(0);
        (r.type.name === "bulletListItem" || r.type.name === "numberedListItem" || r.type.name === "checkListItem") && (s.push(t.child(o + 1)), t = gn(t, o + 1));
      }
      const i = e.state.schema.nodes.blockContainer.createChecked(
        void 0,
        s
      );
      t = t.replaceChild(o, i);
    }
  return new ne(t, n.openStart, n.openEnd);
}
function Sn(n, e) {
  var i, r;
  const t = n.childCount === 1, o = ((i = n.firstChild) == null ? void 0 : i.type.spec.content) === "inline*", s = ((r = n.firstChild) == null ? void 0 : r.type.spec.content) === "tableRow+";
  if (t) {
    if (o)
      return !1;
    if (s) {
      const c = S(e.state);
      if (c.isBlockContainer)
        return !(c.blockContent.node.type.spec.content === "tableRow+");
    }
  }
  return !0;
}
const Bn = {
  enableInputRules: !0,
  enablePasteRules: !0,
  enableCoreExtensions: !1
};
class De extends ye {
  constructor(t) {
    var l, d, u, p, m, f, k, g, y, T;
    super();
    /**
     * The underlying prosemirror schema
     */
    h(this, "pmSchema");
    h(this, "_tiptapEditor");
    /**
     * Used by React to store a reference to an `ElementRenderer` helper utility to make sure we can render React elements
     * in the correct context (used by `ReactRenderUtil`)
     */
    h(this, "elementRenderer", null);
    /**
     * Cache of all blocks. This makes sure we don't have to "recompute" blocks if underlying Prosemirror Nodes haven't changed.
     * This is especially useful when we want to keep track of the same block across multiple operations,
     * with this cache, blocks stay the same object reference (referential equality with ===).
     */
    h(this, "blockCache", /* @__PURE__ */ new WeakMap());
    /**
     * The dictionary contains translations for the editor.
     */
    h(this, "dictionary");
    /**
     * The schema of the editor. The schema defines which Blocks, InlineContent, and Styles are available in the editor.
     */
    h(this, "schema");
    h(this, "blockImplementations");
    h(this, "inlineContentImplementations");
    h(this, "styleImplementations");
    /**
     * The `uploadFile` method is what the editor uses when files need to be uploaded (for example when selecting an image to upload).
     * This method should set when creating the editor as this is application-specific.
     *
     * `undefined` means the application doesn't support file uploads.
     *
     * @param file The file that should be uploaded.
     * @returns The URL of the uploaded file OR an object containing props that should be set on the file block (such as an id)
     */
    h(this, "uploadFile");
    h(this, "onUploadStartCallbacks", []);
    h(this, "onUploadEndCallbacks", []);
    h(this, "resolveFileUrl");
    /**
     * Editor settings
     */
    h(this, "settings");
    // Manager instances
    h(this, "_blockManager");
    h(this, "_eventManager");
    h(this, "_exportManager");
    h(this, "_extensionManager");
    h(this, "_selectionManager");
    h(this, "_stateManager");
    h(this, "_styleManager");
    /**
     * Remove extension(s) from the editor
     */
    h(this, "unregisterExtension", (...t) => this._extensionManager.unregisterExtension(...t));
    /**
     * Register extension(s) to the editor
     */
    h(this, "registerExtension", (...t) => this._extensionManager.registerExtension(...t));
    /**
     * Get an extension from the editor
     */
    h(this, "getExtension", (...t) => this._extensionManager.getExtension(...t));
    /**
     * Mount the editor to a DOM element.
     *
     * @warning Not needed to call manually when using React, use BlockNoteView to take care of mounting
     */
    h(this, "mount", (t) => {
      this._tiptapEditor.mount({ mount: t });
    });
    /**
     * Unmount the editor from the DOM element it is bound to
     */
    h(this, "unmount", () => {
      this._tiptapEditor.unmount();
    });
    this.options = t, this.dictionary = t.dictionary || At, this.settings = {
      tables: {
        splitCells: ((l = t == null ? void 0 : t.tables) == null ? void 0 : l.splitCells) ?? !1,
        cellBackgroundColor: ((d = t == null ? void 0 : t.tables) == null ? void 0 : d.cellBackgroundColor) ?? !1,
        cellTextColor: ((u = t == null ? void 0 : t.tables) == null ? void 0 : u.cellTextColor) ?? !1,
        headers: ((p = t == null ? void 0 : t.tables) == null ? void 0 : p.headers) ?? !1
      }
    };
    const o = {
      defaultStyles: !0,
      schema: t.schema || Et.create(),
      ...t,
      placeholders: {
        ...this.dictionary.placeholders,
        ...t.placeholders
      }
    };
    if (this.schema = o.schema, this.blockImplementations = o.schema.blockSpecs, this.inlineContentImplementations = o.schema.inlineContentSpecs, this.styleImplementations = o.schema.styleSpecs, o.uploadFile) {
      const C = o.uploadFile;
      this.uploadFile = async (P, w) => {
        this.onUploadStartCallbacks.forEach(
          (v) => v.apply(this, [w])
        );
        try {
          return await C(P, w);
        } finally {
          this.onUploadEndCallbacks.forEach(
            (v) => v.apply(this, [w])
          );
        }
      };
    }
    this.resolveFileUrl = o.resolveFileUrl, this._eventManager = new po(this), this._extensionManager = new cn(this, o);
    const s = this._extensionManager.getTiptapExtensions(), i = this._extensionManager.hasExtension("ySync") || this._extensionManager.hasExtension("liveblocksExtension");
    i && o.initialContent && console.warn(
      "When using Collaboration, initialContent might cause conflicts, because changes should come from the collaboration provider"
    );
    const r = {
      ...Bn,
      ...o._tiptapOptions,
      element: null,
      autofocus: o.autofocus ?? !1,
      extensions: s,
      editorProps: {
        ...(m = o._tiptapOptions) == null ? void 0 : m.editorProps,
        attributes: {
          // As of TipTap v2.5.0 the tabIndex is removed when the editor is not
          // editable, so you can't focus it. We want to revert this as we have
          // UI behaviour that relies on it.
          tabIndex: "0",
          ...(k = (f = o._tiptapOptions) == null ? void 0 : f.editorProps) == null ? void 0 : k.attributes,
          ...(g = o.domAttributes) == null ? void 0 : g.editor,
          class: Q(
            "bn-editor",
            o.defaultStyles ? "bn-default-styles" : "",
            ((T = (y = o.domAttributes) == null ? void 0 : y.editor) == null ? void 0 : T.class) || ""
          )
        },
        transformPasted: yn
      }
    };
    try {
      const C = o.initialContent || (i ? [
        {
          type: "paragraph",
          id: "initialBlockId"
        }
      ] : [
        {
          type: "paragraph",
          id: me.options.generateID()
        }
      ]);
      if (!Array.isArray(C) || C.length === 0)
        throw new Error(
          "initialContent must be a non-empty array of blocks, received: " + C
        );
      const P = Pt(r.extensions), w = C.map(
        (Le) => Y(Le, P, this.schema.styleSchema).toJSON()
      ), v = vt(
        {
          type: "doc",
          content: [
            {
              type: "blockGroup",
              content: w
            }
          ]
        },
        P,
        r.parseOptions
      );
      this._tiptapEditor = new It({
        ...r,
        content: v.toJSON()
      }), this.pmSchema = this._tiptapEditor.schema;
    } catch (C) {
      throw new Error(
        "Error creating document from blocks passed as `initialContent`",
        { cause: C }
      );
    }
    let c;
    const a = this.pmSchema.nodes.doc.createAndFill;
    this.pmSchema.nodes.doc.createAndFill = (...C) => {
      if (c)
        return c;
      const P = a.apply(this.pmSchema.nodes.doc, C), w = JSON.parse(JSON.stringify(P.toJSON()));
      return w.content[0].content[0].attrs.id = "initialBlockId", c = He.fromJSON(this.pmSchema, w), c;
    }, this.pmSchema.cached.blockNoteEditor = this, this._blockManager = new uo(this), this._exportManager = new Co(this), this._selectionManager = new fn(this), this._stateManager = new hn(this), this._styleManager = new kn(this), this.emit("create");
  }
  static create(t) {
    return new De(t ?? {});
  }
  /**
   * BlockNote extensions that are added to the editor, keyed by the extension key
   */
  get extensions() {
    return this._extensionManager.getExtensions();
  }
  /**
   * Execute a prosemirror command. This is mostly for backwards compatibility with older code.
   *
   * @note You should prefer the {@link transact} method when possible, as it will automatically handle the dispatching of the transaction and work across blocknote transactions.
   *
   * @example
   * ```ts
   * editor.exec((state, dispatch, view) => {
   *   dispatch(state.tr.insertText("Hello, world!"));
   * });
   * ```
   */
  exec(t) {
    return this._stateManager.exec(t);
  }
  /**
   * Check if a command can be executed. A command should return `false` if it is not valid in the current state.
   *
   * @example
   * ```ts
   * if (editor.canExec(command)) {
   *   // show button
   * } else {
   *   // hide button
   * }
   * ```
   */
  canExec(t) {
    return this._stateManager.canExec(t);
  }
  /**
   * Execute a function within a "blocknote transaction".
   * All changes to the editor within the transaction will be grouped together, so that
   * we can dispatch them as a single operation (thus creating only a single undo step)
   *
   * @note There is no need to dispatch the transaction, as it will be automatically dispatched when the callback is complete.
   *
   * @example
   * ```ts
   * // All changes to the editor will be grouped together
   * editor.transact((tr) => {
   *   tr.insertText("Hello, world!");
   * // These two operations will be grouped together in a single undo step
   *   editor.transact((tr) => {
   *     tr.insertText("Hello, world!");
   *   });
   * });
   * ```
   */
  transact(t) {
    return this._stateManager.transact(t);
  }
  /**
   * Get the underlying prosemirror state
   * @note Prefer using `editor.transact` to read the current editor state, as that will ensure the state is up to date
   * @see https://prosemirror.net/docs/ref/#state.EditorState
   */
  get prosemirrorState() {
    return this._stateManager.prosemirrorState;
  }
  /**
   * Get the underlying prosemirror view
   * @see https://prosemirror.net/docs/ref/#view.EditorView
   */
  get prosemirrorView() {
    return this._stateManager.prosemirrorView;
  }
  get domElement() {
    var t;
    if (!this.headless)
      return (t = this.prosemirrorView) == null ? void 0 : t.dom;
  }
  isFocused() {
    var t;
    return this.headless ? !1 : ((t = this.prosemirrorView) == null ? void 0 : t.hasFocus()) || !1;
  }
  get headless() {
    return !this._tiptapEditor.isInitialized;
  }
  /**
   * Focus on the editor
   */
  focus() {
    this.headless || this.prosemirrorView.focus();
  }
  /**
   * Blur the editor
   */
  blur() {
    this.headless || this.prosemirrorView.dom.blur();
  }
  // TODO move to extension
  onUploadStart(t) {
    return this.onUploadStartCallbacks.push(t), () => {
      const o = this.onUploadStartCallbacks.indexOf(t);
      o > -1 && this.onUploadStartCallbacks.splice(o, 1);
    };
  }
  onUploadEnd(t) {
    return this.onUploadEndCallbacks.push(t), () => {
      const o = this.onUploadEndCallbacks.indexOf(t);
      o > -1 && this.onUploadEndCallbacks.splice(o, 1);
    };
  }
  /**
   * @deprecated, use `editor.document` instead
   */
  get topLevelBlocks() {
    return this.document;
  }
  /**
   * Gets a snapshot of all top-level (non-nested) blocks in the editor.
   * @returns A snapshot of all top-level (non-nested) blocks in the editor.
   */
  get document() {
    return this._blockManager.document;
  }
  /**
   * Gets a snapshot of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block that should be
   * retrieved.
   * @returns The block that matches the identifier, or `undefined` if no
   * matching block was found.
   */
  getBlock(t) {
    return this._blockManager.getBlock(t);
  }
  /**
   * Gets a snapshot of the previous sibling of an existing block from the
   * editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * previous sibling should be retrieved.
   * @returns The previous sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the first child/block
   * in the document.
   */
  getPrevBlock(t) {
    return this._blockManager.getPrevBlock(t);
  }
  /**
   * Gets a snapshot of the next sibling of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * next sibling should be retrieved.
   * @returns The next sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the last child/block in
   * the document.
   */
  getNextBlock(t) {
    return this._blockManager.getNextBlock(t);
  }
  /**
   * Gets a snapshot of the parent of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * parent should be retrieved.
   * @returns The parent of the block that matches the identifier. `undefined`
   * if no matching block was found, or the block isn't nested.
   */
  getParentBlock(t) {
    return this._blockManager.getParentBlock(t);
  }
  /**
   * Traverses all blocks in the editor depth-first, and executes a callback for each.
   * @param callback The callback to execute for each block. Returning `false` stops the traversal.
   * @param reverse Whether the blocks should be traversed in reverse order.
   */
  forEachBlock(t, o = !1) {
    this._blockManager.forEachBlock(t, o);
  }
  /**
   * Executes a callback whenever the editor's contents change.
   * @param callback The callback to execute.
   *
   * @deprecated use {@link BlockNoteEditor.onChange} instead
   */
  onEditorContentChange(t) {
    this._tiptapEditor.on("update", t);
  }
  /**
   * Executes a callback whenever the editor's selection changes.
   * @param callback The callback to execute.
   *
   * @deprecated use `onSelectionChange` instead
   */
  onEditorSelectionChange(t) {
    this._tiptapEditor.on("selectionUpdate", t);
  }
  /**
   * Gets a snapshot of the current text cursor position.
   * @returns A snapshot of the current text cursor position.
   */
  getTextCursorPosition() {
    return this._selectionManager.getTextCursorPosition();
  }
  /**
   * Sets the text cursor position to the start or end of an existing block. Throws an error if the target block could
   * not be found.
   * @param targetBlock The identifier of an existing block that the text cursor should be moved to.
   * @param placement Whether the text cursor should be placed at the start or end of the block.
   */
  setTextCursorPosition(t, o = "start") {
    return this._selectionManager.setTextCursorPosition(t, o);
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned data will contain the entire block.
   */
  getSelection() {
    return this._selectionManager.getSelection();
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned block will be
   * only the part of the block that is included in the selection.
   */
  getSelectionCutBlocks() {
    return this._selectionManager.getSelectionCutBlocks();
  }
  /**
   * Sets the selection to a range of blocks.
   * @param startBlock The identifier of the block that should be the start of the selection.
   * @param endBlock The identifier of the block that should be the end of the selection.
   */
  setSelection(t, o) {
    return this._selectionManager.setSelection(t, o);
  }
  /**
   * Checks if the editor is currently editable, or if it's locked.
   * @returns True if the editor is editable, false otherwise.
   */
  get isEditable() {
    return this._stateManager.isEditable;
  }
  /**
   * Makes the editor editable or locks it, depending on the argument passed.
   * @param editable True to make the editor editable, or false to lock it.
   */
  set isEditable(t) {
    this._stateManager.isEditable = t;
  }
  /**
   * Inserts new blocks into the editor. If a block's `id` is undefined, BlockNote generates one automatically. Throws an
   * error if the reference block could not be found.
   * @param blocksToInsert An array of partial blocks that should be inserted.
   * @param referenceBlock An identifier for an existing block, at which the new blocks should be inserted.
   * @param placement Whether the blocks should be inserted just before, just after, or nested inside the
   * `referenceBlock`.
   */
  insertBlocks(t, o, s = "before") {
    return this._blockManager.insertBlocks(
      t,
      o,
      s
    );
  }
  /**
   * Updates an existing block in the editor. Since updatedBlock is a PartialBlock object, some fields might not be
   * defined. These undefined fields are kept as-is from the existing block. Throws an error if the block to update could
   * not be found.
   * @param blockToUpdate The block that should be updated.
   * @param update A partial block which defines how the existing block should be changed.
   */
  updateBlock(t, o) {
    return this._blockManager.updateBlock(t, o);
  }
  /**
   * Removes existing blocks from the editor. Throws an error if any of the blocks could not be found.
   * @param blocksToRemove An array of identifiers for existing blocks that should be removed.
   */
  removeBlocks(t) {
    return this._blockManager.removeBlocks(t);
  }
  /**
   * Replaces existing blocks in the editor with new blocks. If the blocks that should be removed are not adjacent or
   * are at different nesting levels, `blocksToInsert` will be inserted at the position of the first block in
   * `blocksToRemove`. Throws an error if any of the blocks to remove could not be found.
   * @param blocksToRemove An array of blocks that should be replaced.
   * @param blocksToInsert An array of partial blocks to replace the old ones with.
   */
  replaceBlocks(t, o) {
    return this._blockManager.replaceBlocks(t, o);
  }
  /**
   * Undo the last action.
   */
  undo() {
    return this._stateManager.undo();
  }
  /**
   * Redo the last action.
   */
  redo() {
    return this._stateManager.redo();
  }
  /**
   * Insert a piece of content at the current cursor position.
   *
   * @param content can be a string, or array of partial inline content elements
   */
  insertInlineContent(t, { updateSelection: o = !1 } = {}) {
    this._styleManager.insertInlineContent(t, { updateSelection: o });
  }
  /**
   * Gets the active text styles at the text cursor position or at the end of the current selection if it's active.
   */
  getActiveStyles() {
    return this._styleManager.getActiveStyles();
  }
  /**
   * Adds styles to the currently selected content.
   * @param styles The styles to add.
   */
  addStyles(t) {
    this._styleManager.addStyles(t);
  }
  /**
   * Removes styles from the currently selected content.
   * @param styles The styles to remove.
   */
  removeStyles(t) {
    this._styleManager.removeStyles(t);
  }
  /**
   * Toggles styles on the currently selected content.
   * @param styles The styles to toggle.
   */
  toggleStyles(t) {
    this._styleManager.toggleStyles(t);
  }
  /**
   * Gets the currently selected text.
   */
  getSelectedText() {
    return this._styleManager.getSelectedText();
  }
  /**
   * Gets the URL of the last link in the current selection, or `undefined` if there are no links in the selection.
   */
  getSelectedLinkUrl() {
    return this._styleManager.getSelectedLinkUrl();
  }
  /**
   * Creates a new link to replace the selected content.
   * @param url The link URL.
   * @param text The text to display the link with.
   */
  createLink(t, o) {
    this._styleManager.createLink(t, o);
  }
  /**
   * Checks if the block containing the text cursor can be nested.
   */
  canNestBlock() {
    return this._blockManager.canNestBlock();
  }
  /**
   * Nests the block containing the text cursor into the block above it.
   */
  nestBlock() {
    this._blockManager.nestBlock();
  }
  /**
   * Checks if the block containing the text cursor is nested.
   */
  canUnnestBlock() {
    return this._blockManager.canUnnestBlock();
  }
  /**
   * Lifts the block containing the text cursor out of its parent.
   */
  unnestBlock() {
    this._blockManager.unnestBlock();
  }
  /**
   * Moves the selected blocks up. If the previous block has children, moves
   * them to the end of its children. If there is no previous block, but the
   * current blocks share a common parent, moves them out of & before it.
   */
  moveBlocksUp() {
    return this._blockManager.moveBlocksUp();
  }
  /**
   * Moves the selected blocks down. If the next block has children, moves
   * them to the start of its children. If there is no next block, but the
   * current blocks share a common parent, moves them out of & after it.
   */
  moveBlocksDown() {
    return this._blockManager.moveBlocksDown();
  }
  /**
   * Exports blocks into a simplified HTML string. To better conform to HTML standards, children of blocks which aren't list
   * items are un-nested in the output HTML.
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToHTMLLossy(t = this.document) {
    return this._exportManager.blocksToHTMLLossy(t);
  }
  /**
   * Serializes blocks into an HTML string in the format that would normally be rendered by the editor.
   *
   * Use this method if you want to server-side render HTML (for example, a blog post that has been edited in BlockNote)
   * and serve it to users without loading the editor on the client (i.e.: displaying the blog post)
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToFullHTML(t = this.document) {
    return this._exportManager.blocksToFullHTML(t);
  }
  /**
   * Parses blocks from an HTML string. Tries to create `Block` objects out of any HTML block-level elements, and
   * `InlineNode` objects from any HTML inline elements, though not all element types are recognized. If BlockNote
   * doesn't recognize an HTML element's tag, it will parse it as a paragraph or plain text.
   * @param html The HTML string to parse blocks from.
   * @returns The blocks parsed from the HTML string.
   */
  tryParseHTMLToBlocks(t) {
    return this._exportManager.tryParseHTMLToBlocks(t);
  }
  /**
   * Serializes blocks into a Markdown string. The output is simplified as Markdown does not support all features of
   * BlockNote - children of blocks which aren't list items are un-nested and certain styles are removed.
   * @param blocks An array of blocks that should be serialized into Markdown.
   * @returns The blocks, serialized as a Markdown string.
   */
  blocksToMarkdownLossy(t = this.document) {
    return this._exportManager.blocksToMarkdownLossy(t);
  }
  /**
   * Creates a list of blocks from a Markdown string. Tries to create `Block` and `InlineNode` objects based on
   * Markdown syntax, though not all symbols are recognized. If BlockNote doesn't recognize a symbol, it will parse it
   * as text.
   * @param markdown The Markdown string to parse blocks from.
   * @returns The blocks parsed from the Markdown string.
   */
  tryParseMarkdownToBlocks(t) {
    return this._exportManager.tryParseMarkdownToBlocks(t);
  }
  /**
   * A callback function that runs whenever the editor's contents change.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onChange(t, o) {
    return this._eventManager.onChange(t, o);
  }
  /**
   * A callback function that runs whenever the text cursor position or selection changes.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onSelectionChange(t, o) {
    return this._eventManager.onSelectionChange(
      t,
      o
    );
  }
  /**
   * A callback function that runs when the editor has been mounted.
   *
   * This can be useful for plugins to initialize themselves after the editor has been mounted.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onMount(t) {
    this._eventManager.onMount(t);
  }
  /**
   * A callback function that runs when the editor has been unmounted.
   *
   * This can be useful for plugins to clean up themselves after the editor has been unmounted.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onUnmount(t) {
    this._eventManager.onUnmount(t);
  }
  /**
   * Gets the bounding box of the current selection.
   * @returns The bounding box of the current selection.
   */
  getSelectionBoundingBox() {
    return this._selectionManager.getSelectionBoundingBox();
  }
  get isEmpty() {
    const t = this.document;
    return t.length === 0 || t.length === 1 && t[0].type === "paragraph" && t[0].content.length === 0;
  }
  /**
   * Paste HTML into the editor. Defaults to converting HTML to BlockNote HTML.
   * @param html The HTML to paste.
   * @param raw Whether to paste the HTML as is, or to convert it to BlockNote HTML.
   */
  pasteHTML(t, o = !1) {
    this._exportManager.pasteHTML(t, o);
  }
  /**
   * Paste text into the editor. Defaults to interpreting text as markdown.
   * @param text The text to paste.
   */
  pasteText(t) {
    return this._exportManager.pasteText(t);
  }
  /**
   * Paste markdown into the editor.
   * @param markdown The markdown to paste.
   */
  pasteMarkdown(t) {
    return this._exportManager.pasteMarkdown(t);
  }
}
class Yn {
  constructor(e, t, o) {
    this.mappings = t, this.options = o;
  }
  async resolveFile(e) {
    var o;
    if (!((o = this.options) != null && o.resolveFileUrl))
      return (await fetch(e)).blob();
    const t = await this.options.resolveFileUrl(e);
    return t instanceof Blob ? t : (await fetch(t)).blob();
  }
  mapStyles(e) {
    return Object.entries(e).map(([o, s]) => this.mappings.styleMapping[o](s, this));
  }
  mapInlineContent(e) {
    return this.mappings.inlineContentMapping[e.type](
      e,
      this
    );
  }
  transformInlineContent(e) {
    return e.map((t) => this.mapInlineContent(t));
  }
  async mapBlock(e, t, o, s) {
    return this.mappings.blockMapping[e.type](
      e,
      this,
      t,
      o,
      s
    );
  }
}
function qn(n) {
  return {
    createBlockMapping: (e) => e,
    createInlineContentMapping: (e) => e,
    createStyleMapping: (e) => e
  };
}
function Qn(n, ...e) {
  const t = [...n];
  for (const o of e)
    for (const s of o) {
      const i = t.findLastIndex(
        (r) => r.group === s.group
      );
      i === -1 ? t.push(s) : t.splice(i + 1, 0, s);
    }
  return t;
}
export {
  De as BlockNoteEditor,
  Et as BlockNoteSchema,
  ms as COLORS_DARK_MODE_DEFAULT,
  ks as COLORS_DEFAULT,
  Yr as CustomBlockNoteSchema,
  gs as EMPTY_CELL_HEIGHT,
  bs as EMPTY_CELL_WIDTH,
  ye as EventEmitter,
  Yn as Exporter,
  ys as FILE_AUDIO_ICON_SVG,
  Ss as FILE_IMAGE_ICON_SVG,
  Bs as FILE_VIDEO_ICON_SVG,
  Te as HTMLToBlocks,
  me as UniqueID,
  F as UnreachableCaseError,
  Cs as addDefaultPropsExternalHTML,
  $ as addInlineContentAttributes,
  je as addInlineContentKeyboardShortcuts,
  Es as addNodeAndExtensionsToSpec,
  xs as addStyleAttributes,
  Ms as applyNonSelectableBlockFix,
  es as assertEmpty,
  ws as audioParse,
  Ts as audioRender,
  Ps as audioToExternalHTML,
  vs as blockHasType,
  Y as blockToNode,
  ot as blocksToMarkdown,
  Is as camelToDataKebab,
  As as captureCellAnchor,
  qr as checkPageBreakBlocksInSchema,
  nt as cleanHTMLToMarkdown,
  Qn as combineByGroup,
  Ge as contentNodeToInlineContent,
  ze as contentNodeToTableContent,
  _s as createAudioBlockConfig,
  Ds as createAudioBlockSpec,
  Ls as createBlockConfig,
  Ns as createBlockSpec,
  Os as createBlockSpecFromTiptapNode,
  Fs as createBulletListItemBlockConfig,
  Hs as createBulletListItemBlockSpec,
  $s as createCheckListItemBlockSpec,
  Vs as createCheckListItemConfig,
  Us as createCodeBlockConfig,
  zs as createCodeBlockSpec,
  Gs as createDefaultBlockDOMOutputSpec,
  Rs as createDividerBlockConfig,
  js as createDividerBlockSpec,
  ni as createExtension,
  be as createExternalHTMLExporter,
  Ws as createFileBlockConfig,
  Ks as createFileBlockSpec,
  Js as createHeadingBlockConfig,
  Ys as createHeadingBlockSpec,
  qs as createImageBlockConfig,
  Qs as createImageBlockSpec,
  Jn as createInlineContentSpec,
  Ke as createInlineContentSpecFromTipTapNode,
  Qt as createInternalHTMLSerializer,
  Xs as createInternalInlineContentSpec,
  Zs as createInternalStyleSpec,
  er as createNumberedListItemBlockConfig,
  tr as createNumberedListItemBlockSpec,
  Qr as createPageBreakBlockConfig,
  Xr as createPageBreakBlockSpec,
  or as createParagraphBlockConfig,
  nr as createParagraphBlockSpec,
  sr as createQuoteBlockConfig,
  rr as createQuoteBlockSpec,
  si as createStore,
  ir as createStyleSpec,
  ar as createStyleSpecFromTipTapMark,
  cr as createTableBlockSpec,
  lr as createToggleListItemBlockConfig,
  dr as createToggleListItemBlockSpec,
  ur as createToggleWrapper,
  pr as createVideoBlockConfig,
  fr as createVideoBlockSpec,
  hr as defaultBlockSpecs,
  mr as defaultBlockToHTML,
  kr as defaultInlineContentSchema,
  gr as defaultInlineContentSpecs,
  br as defaultProps,
  yr as defaultStyleSchema,
  Sr as defaultStyleSpecs,
  Br as defaultToggledState,
  Ue as docToBlocks,
  Cr as editorHasBlockWithType,
  Er as fileParse,
  xr as filenameFromURL,
  W as fixColumnList,
  Mr as formatKeyboardShortcut,
  qe as getBackgroundColorAttribute,
  io as getBlock,
  ts as getBlockCache,
  wr as getBlockFromPos,
  z as getBlockInfo,
  q as getBlockInfoFromResolvedPos,
  S as getBlockInfoFromSelection,
  H as getBlockInfoFromTransaction,
  os as getBlockInfoWithManualOffset,
  ke as getBlockNoteSchema,
  ns as getBlockSchema,
  tt as getBlocksChangedByTransaction,
  ss as getColspan,
  Wt as getInlineContentParseRules,
  rs as getInlineContentSchema,
  Tr as getInlineContentSchemaFromSpecs,
  Pr as getLanguageId,
  _ as getNearestBlockPos,
  co as getNextBlock,
  E as getNodeById,
  Zr as getPageBreakSlashMenuItems,
  lo as getParentBlock,
  vr as getParseRules,
  B as getPmSchema,
  ao as getPrevBlock,
  is as getRowspan,
  Ir as getStyleParseRules,
  as as getStyleSchema,
  Ar as getStyleSchemaFromSpecs,
  _r as getTextAlignmentAttribute,
  Ze as getTextColorAttribute,
  Dr as imageParse,
  Lr as imageRender,
  Nr as imageToExternalHTML,
  O as inlineContentToNodes,
  Kt as insertBlocks,
  Or as isAppleOS,
  j as isEmptyColumn,
  cs as isLinkInlineContent,
  Fr as isNodeBlock,
  ls as isPartialLinkInlineContent,
  ds as isPartialTableCell,
  Hr as isSafari,
  us as isStyledTextInlineContent,
  ps as isTableCell,
  $r as isTableCellSelection,
  Ye as isVideoUrl,
  fs as mapTableCell,
  qn as mappingFactory,
  Bo as markdownToBlocks,
  Pe as markdownToHTML,
  Q as mergeCSSClasses,
  Vr as mergeParagraphs,
  b as nodeToBlock,
  U as nodeToCustomInlineContent,
  Ur as parseAudioElement,
  zr as parseDefaultProps,
  We as propsToAttributes,
  Re as prosemirrorSliceToSlicedBlocks,
  ie as removeAndInsertBlocks,
  Jt as removeEmptyColumns,
  Ie as selectedFragmentToHTML,
  Gr as stylePropsToAttributes,
  Ve as tableContentToNodes,
  Rr as tablePropSchema,
  jr as trackPosition,
  Je as updateBlock,
  Xe as updateBlockCommand,
  et as updateBlockTr,
  ei as uploadToTmpFilesDotOrg_DEV_ONLY,
  Wr as videoParse,
  ti as withPageBreak,
  Kr as wrapInBlockStructure
};
//# sourceMappingURL=blocknote.js.map
